/*
  ==================================================================
  Silberkraft — Flow-Engine fuer die gefuehrten Fall-Strecken
  ==================================================================
  Laeuft auf allen Seiten mit Template-Suffix "hilfe-fall".
  Die Optik kommt komplett aus snippets/sk-flow-kit.liquid (.skf-*).
  Diese Datei enthaelt KEINEN sichtbaren Text — jeder String kommt
  aus window.SK_FLOW.t, das die Section aus Locale-Keys baut.

  VERTRAG MIT DER ERP-API  (build-01-fundament.md, Abschnitt 3.1)
  ------------------------------------------------------------------
  POST  {api}/self-service/sessions
        { orderRef, zip?, lastName?, email?, locale }
        201 -> { data: { sessionId, sessionToken, verificationLevel,
                         channel, order:{...}, tracking:{...}|null } }
        401 verification_required · 404 not_resolvable
        409 channel_unsupported  · 429 rate_limited · 503 lookup_incomplete
  POST  {api}/self-service/sessions/:id/media/upload-url
        { fileName, contentType, fileSizeBytes }
        -> { data: { uploadUrl, objectKey, requiredHeaders{...} } }
        ⚠ BEIDE requiredHeaders muessen beim PUT mit — sie sind Teil der Signatur.
  POST  {api}/self-service/sessions/:id/cases
        { caseType, answers, customerMessage, customerName, media[], locale }
        201 -> { data: { caseId, caseNumber, customerVisibleState } }
  GET   {api}/self-service/sessions/:id/invoices | /tracking | /cases
  Auth: Authorization: Bearer <sessionToken>

  REGELN
  ------------------------------------------------------------------
  • Kein Einweg-Flow: jeder Schritt hat eine eigene URL (?schritt=<id>),
    "Zurueck" ist ein echtes <a href>, popstate wird bedient.
  • Ohne JavaScript bleibt die serverseitig gerenderte Startkarte inkl.
    Kontaktweg stehen — diese Datei ersetzt sie erst, wenn sie laeuft.
  • Kein Cross-Selling, kein Newsletter, keine Lieferantennamen.
  • Fristen stehen auf der Startkarte, nicht im Kleingedruckten.
*/
(function () {
  'use strict';

  var CFG = window.SK_FLOW;
  if (!CFG || !CFG.flow) return;

  var app = document.querySelector('[data-skflow-app]');
  if (!app) return;

  var T = CFG.t || {};
  var API = String(CFG.api || '').replace(/\/+$/, '');
  var FLOW = CFG.flow;
  /* Seiten-Kachel, die der Kunde angeklickt hat — bleibt stabil, auch wenn
     die Strecke nach dem Versandstatus umgeleitet wird (Storno <-> Widerruf). */
  var ENTRY_FLOW_ID = FLOW.id;
  var STORE_KEY = 'skflow:' + FLOW.id;

  /* ============================================================
     Kleinkram
     ============================================================ */

  /* Shopifys `| t`-Filter liefert HTML-escapte Strings. Weil jeder Text hier
     ueber textContent gesetzt wird (el()), stand auf silberkraft.fr/.it/.es
     woertlich "D&#39;après notre système" statt "D'après ...".
     Deshalb EINMAL zentral zurueckwandeln. Kein XSS-Risiko: die Strings
     stammen aus unseren Locale-Dateien und landen ausschliesslich als Text. */
  var SKF_ENTITIES = {
    '&#39;': "'", '&#x27;': "'", '&#x2F;': '/', '&quot;': '"',
    '&lt;': '<', '&gt;': '>', '&nbsp;': ' ', '&amp;': '&'
  };

  function decodeEntities(s) {
    return String(s).replace(/&(?:#39|#x27|#x2F|quot|lt|gt|nbsp|amp);/g, function (m) {
      return SKF_ENTITIES[m] !== undefined ? SKF_ENTITIES[m] : m;
    });
  }

  function t(key, vars) {
    var s = T[key];
    if (s === undefined || s === null) return '';
    s = decodeEntities(s);
    if (!vars) return s;
    return s.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (m, name) {
      return vars[name] === undefined || vars[name] === null ? '' : String(vars[name]);
    });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = String(text);
    return n;
  }

  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }

  function money(value, currency) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    try {
      return new Intl.NumberFormat(CFG.locale || 'de', {
        style: 'currency', currency: currency || 'EUR'
      }).format(num);
    } catch (e) { return num.toFixed(2) + ' ' + (currency || 'EUR'); }
  }

  function niceDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    try {
      return d.toLocaleDateString(CFG.locale || 'de', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { return d.toISOString().slice(0, 10); }
  }

  function niceDateTime(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    try {
      return d.toLocaleString(CFG.locale || 'de', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
      });
    } catch (e) { return d.toISOString().slice(0, 16).replace('T', ' '); }
  }

  function daysBetween(a, b) {
    var d1 = new Date(a), d2 = b ? new Date(b) : new Date();
    if (isNaN(d1.getTime())) return null;
    return Math.floor((d2 - d1) / 86400000);
  }

  /* ============================================================
     Zustand
     ============================================================ */

  var S = {
    session: null,   /* { id, token, level, channel, order, tracking, canUpgrade, upgradeTarget } */
    answers: {},
    files: [],       /* File-Objekte, noch nicht hochgeladen */
    media: [],       /* { objectKey, mimeType, sizeBytes } */
    invoices: null,
    cases: null,
    abgabe: null,    /* GET /abgabe: { pending, completed, windows, phoneMasked, hasPhone, existingRequest } */
    result: null,
    busy: false
  };

  /* Die Sitzung liegt flow-UEBERGREIFEND, die Antworten pro Fall. Sonst muesste
     der Kunde seine Bestellnummer noch einmal eintippen, nur weil ihn eine
     Antwort in die passendere Strecke geschickt hat. */
  var SESSION_KEY = 'skflow:session';

  function persist() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(S.session));
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        answers: S.answers, media: S.media, result: S.result, abgabe: S.abgabe
      }));
    } catch (e) { /* Private Mode o. ae. — Flow laeuft trotzdem, nur ohne Reload-Schutz */ }
  }

  function restore() {
    try {
      var rawS = sessionStorage.getItem(SESSION_KEY);
      if (rawS) {
        var sess = JSON.parse(rawS);
        if (sess && sess.id && sess.token) S.session = sess;
      }
    } catch (e) { /* kaputter Eintrag */ }
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var d = JSON.parse(raw);
      /* Altform (Sitzung lag im Flow-Eintrag) weiter lesen koennen */
      if (!S.session && d && d.session) S.session = d.session;
      if (d && d.answers) S.answers = d.answers;
      if (d && d.media) S.media = d.media;
      if (d && d.result) S.result = d.result;
      if (d && d.abgabe) S.abgabe = d.abgabe;
    } catch (e) { /* kaputter Eintrag — dann eben von vorn */ }
  }

  /* forget(true) = auch die Bestellung vergessen ("Andere Bestellung").
     forget()     = nur die Antworten dieses Falls. */
  function forget(dropSession) {
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    S.answers = {}; S.files = []; S.media = [];
    S.invoices = null; S.cases = null; S.result = null; S.abgabe = null;
    if (dropSession) {
      try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      S.session = null;
    }
    S.flowSwitch = null;
    FLOW = CFG.flow;
  }

  /* ============================================================
     Richtige Tuer: Storno <-> Widerruf folgt dem VERSANDSTATUS,
     nicht der angeklickten Kachel.
     ------------------------------------------------------------
     Ein Storno ist rechtlich etwas anderes als ein Widerruf nach
     Versand. Waehlt der Kunde "Storno", die Bestellung ist laut API
     aber schon versendet, sagen wir das ehrlich und fuehren nahtlos
     durch den Widerruf weiter (caseType folgt der Umleitung) — und
     umgekehrt: "Widerruf" bei unversendeter Bestellung wird zum
     einfachen Storno ("gute Nachricht: noch nicht versendet").
     Unklare Zustaende (Teillieferung, keine Daten) leiten NIE um.
     ============================================================ */

  /* ------------------------------------------------------------------
     Stoppbarkeit — PFADABHAENGIG, nicht mehr "versendet ja/nein".

     Bis 26.08.2026 stand hier ein Vergleich auf o.fulfillmentStatus
     ('fulfilled'/'unfulfilled') plus Trackingnummer. Das war doppelt falsch:

       1. Das Feld traegt ein UEBERSETZTES Label ("Versendet" / "In
          Bearbeitung"), nie 'fulfilled' — der Zweig 'not_shipped' konnte
          also NIE greifen. Die Umleitung Widerruf -> Storno war tot.
       2. Selbst mit richtigem Vergleich waere die Aussage falsch gewesen:
          Bei Nuetzlingen entsteht die Trackingnummer schon bei der
          LABEL-Erzeugung, Stunden bevor die Ware an die Zuchtstation
          uebergeben wird — die Bestellung galt als "versendet", war aber
          voll stoppbar. Umgekehrt ist Lagerware ab dem Lieferschein schon
          uebertragen, obwohl noch keine Trackingnummer existiert.

     Wahrheit ist jetzt data.stopability aus dem ERP. Der Alt-Pfad bleibt
     nur als Fallback, falls die API das Feld (noch) nicht liefert.
     ------------------------------------------------------------------ */

  function stopability() {
    return (S.session && S.session.stopability) || null;
  }

  function shippedState() {
    if (!S.session) return 'unknown';
    var st = stopability();
    if (st && st.stoppable) {
      if (st.stoppable === 'yes') return 'not_shipped';
      if (st.stoppable === 'no') return 'shipped';
      return 'unknown';
    }
    /* Fallback (alte API): bewusst nur die belegbare Richtung. */
    var o = S.session.order || {};
    var tr = S.session.tracking || null;
    var ff = String(o.fulfillmentStatus || '').toLowerCase();
    if (ff === 'fulfilled' || (tr && tr.trackingNumber)) return 'shipped';
    return 'unknown';
  }

  /* "Ein Teil ja, ein Teil nein" ehrlich benennen. */
  function stopabilitySplitNote() {
    var st = stopability();
    if (!st || !st.split || !st.groups || !st.groups.length) return null;
    var parts = st.groups.map(function (g) {
      var label = t('st_path_' + (g.kind || 'other')) || t('st_path_other');
      var verdict = t('st_part_' + (g.stoppable || 'unknown'));
      var until = g.stoppable === 'yes' && g.until
        ? ' (' + t('st_stop_until', { time: niceDateTime(g.until) }) + ')'
        : '';
      return label + ' — ' + verdict + until;
    });
    return note('warn', t('st_stop_split', { parts: parts.join(' · ') }));
  }

  /* Der eine Satz zur Stoppbarkeit auf dem Storno-Weg. */
  function stopabilityNote() {
    var st = stopability();
    if (!st || !st.stoppable) return null;
    if (st.split) return null; /* dann sagt die Split-Notiz mehr */
    if (st.stoppable === 'yes') {
      return note('good', st.stoppableUntil
        ? t('st_stop_yes_until', { time: niceDateTime(st.stoppableUntil) })
        : t('st_stop_yes'));
    }
    if (st.stoppable === 'no') return note('warn', t('st_stop_no'));
    return note('warn', t('st_stop_unknown'));
  }

  function niceDateTime(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleString(CFG.locale || 'de', {
        weekday: 'long', hour: '2-digit', minute: '2-digit'
      });
    } catch (e) {
      return d.toLocaleString();
    }
  }

  function applyFlowSwitch() {
    if (!CFG.flows) return;
    if (ENTRY_FLOW_ID !== 'storno' && ENTRY_FLOW_ID !== 'retoure') return;
    var st = shippedState();
    var target = null;
    if (FLOW.id === 'storno' && st === 'shipped') target = 'retoure';
    else if (FLOW.id === 'retoure' && st === 'not_shipped') target = 'storno';
    if (!target || !CFG.flows[target]) return;
    FLOW = CFG.flows[target];
    S.flowSwitch = target === ENTRY_FLOW_ID ? null : { from: ENTRY_FLOW_ID, to: target };
  }

  /* Der Hinweis, der die Umleitung auf JEDEM Schritt erklaert. */
  function flowSwitchNote() {
    if (!S.flowSwitch) return null;
    if (S.flowSwitch.to === 'retoure') return note('warn', t('sw_to_widerruf'));
    if (S.flowSwitch.to === 'storno') return note('good', t('sw_to_storno'));
    return null;
  }

  /* ============================================================
     Netzwerk
     ============================================================ */

  function api(path, opts) {
    opts = opts || {};
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    if (opts.auth !== false && S.session && S.session.token) {
      headers['Authorization'] = 'Bearer ' + S.session.token;
    }
    return fetch(API + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'omit',
      mode: 'cors'
    }).then(function (res) {
      return res.text().then(function (txt) {
        var json = null;
        try { json = txt ? JSON.parse(txt) : null; } catch (e) { json = null; }
        if (!res.ok) {
          var err = new Error((json && json.error && json.error.message) || t('err_generic'));
          err.status = res.status;
          err.code = (json && json.error && json.error.code) || null;
          err.payload = json && json.error ? json.error : null;
          throw err;
        }
        return json && json.data !== undefined ? json.data : json;
      });
    }, function () {
      var err = new Error(t('err_network'));
      err.status = 0; err.code = 'network';
      throw err;
    });
  }

  function messageForError(err) {
    if (!err) return t('err_generic');
    switch (err.code) {
      case 'network': return t('err_network');
      case 'not_resolvable': return t('err_not_found');
      case 'verification_required': return t('err_verification');
      case 'rate_limited': return t('err_rate_limited');
      case 'channel_unsupported': return t('err_channel_amazon');
      case 'lookup_incomplete': return t('err_lookup_incomplete');
      case 'level_required': return t('err_level_required');
      case 'case_not_dispatched': return t('err_case_failed');
      case 'media_rejected': return err.message || t('err_upload_failed');
      default: break;
    }
    if (err.status === 401) return t('err_session_expired');
    if (err.status === 404) return t('err_not_found');
    if (err.status === 429) return t('err_rate_limited');
    return err.message || t('err_generic');
  }

  /* Upload: signierte URL holen, dann direkt nach GCS PUTten. */
  function uploadFile(file, onProgress) {
    return api('/self-service/sessions/' + S.session.id + '/media/upload-url', {
      method: 'POST',
      body: { fileName: file.name, contentType: file.type || 'application/octet-stream', fileSizeBytes: file.size }
    }).then(function (signed) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', signed.uploadUrl, true);
        var hdrs = signed.requiredHeaders || {};
        Object.keys(hdrs).forEach(function (h) { xhr.setRequestHeader(h, hdrs[h]); });
        if (xhr.upload && onProgress) {
          xhr.upload.onprogress = function (e) {
            if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
          };
        }
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve({ objectKey: signed.objectKey, mimeType: file.type || 'application/octet-stream', sizeBytes: file.size });
          } else {
            var e2 = new Error(t('err_upload_failed')); e2.status = xhr.status; reject(e2);
          }
        };
        xhr.onerror = function () { var e3 = new Error(t('err_upload_failed')); e3.code = 'network'; reject(e3); };
        xhr.send(file);
      });
    });
  }

  /* ============================================================
     Schrittliste
     ============================================================ */

  function condOk(cond) {
    if (!cond) return true;
    var val = S.answers[cond.key];
    if (cond.in) {
      if (Array.isArray(val)) return val.some(function (v) { return cond.in.indexOf(v) !== -1; });
      return cond.in.indexOf(val) !== -1;
    }
    if (cond.notIn) {
      if (Array.isArray(val)) return !val.some(function (v) { return cond.notIn.indexOf(v) !== -1; });
      return cond.notIn.indexOf(val) === -1;
    }
    if (cond.truthy) return !!val;
    if (cond.ctx === 'multi_invoice') return !!(S.invoices && S.invoices.length > 1);
    if (cond.ctx === 'delivered') {
      var st = S.session && S.session.tracking ? String(S.session.tracking.status || '') : '';
      return /deliver|zugestellt/i.test(st);
    }
    if (cond.ctx === 'pack_selected') return packSelections().length > 0;
    if (cond.ctx === 'multi_item') {
      return !!(S.session && S.session.order && S.session.order.items && S.session.order.items.length > 1);
    }
    return true;
  }

  /* Sendet dieser Flow ueberhaupt einen Fall? "sendung" und "rechnung" enden
     im Regelfall in einer Auskunft — ein Ticket entsteht dort NICHT. */
  function wantsSubmit() {
    if (FLOW.submits === false) return false;
    if (FLOW.submits === 'conditional') {
      return (FLOW.submitWhen || []).some(function (c) { return !!S.answers[c.key]; });
    }
    return true;
  }

  /* Aktive Schritte in Reihenfolge — ident ist immer der erste. */
  function activeSteps() {
    var out = [{ id: 'ident', kind: 'ident' }];
    (FLOW.steps || []).forEach(function (st) {
      if (condOk(st.when)) out.push(st);
    });
    if (wantsSubmit()) {
      out.push({ id: 'pruefen', kind: 'review' });
      out.push({ id: 'fertig', kind: 'done' });
    }
    return out;
  }

  function stepIndex(id) {
    var list = activeSteps();
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return i;
    return -1;
  }

  function stepById(id) {
    var list = activeSteps();
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }

  /* ============================================================
     Navigation — Zustand steckt in der URL
     ============================================================ */

  function currentStepId() {
    var m = /[?&]schritt=([^&#]+)/.exec(window.location.search);
    if (m) return decodeURIComponent(m[1]);
    /* Aus dem Hilfe-Center kommt die Bestellnummer als ?ref= mit — dann
       direkt in die Identifikation, statt den Nutzer noch einmal klicken
       zu lassen. Der Wert wird NUR vorbelegt, nie automatisch abgeschickt. */
    if (prefillRef()) return 'ident';
    return 'start';
  }

  function prefillRef() {
    var m = /[?&]ref=([^&#]*)/.exec(window.location.search);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim(); }
    catch (e) { return ''; }
  }

  function urlFor(stepId) {
    return window.location.pathname + (stepId === 'start' ? '' : '?schritt=' + encodeURIComponent(stepId));
  }

  function go(stepId, replace) {
    var url = urlFor(stepId);
    try {
      if (replace) window.history.replaceState({ skflow: stepId }, '', url);
      else window.history.pushState({ skflow: stepId }, '', url);
    } catch (e) { /* history gesperrt — dann bleibt die URL stehen */ }
    render(stepId);
    var h = app.querySelector('h1, h2');
    if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: false }); } catch (e2) { h.focus(); } }
    else window.scrollTo(0, 0);
  }

  window.addEventListener('popstate', function () { render(currentStepId()); });

  /* Ein Schritt, den der Nutzer ohne Sitzung nicht sehen kann, faellt zurueck. */
  function guard(stepId) {
    /* Tueren sind reine Wegweiser: es gibt dort weder Identifikation noch
       Review — ein Deep-Link auf ?schritt=... darf nie in einem leeren
       "Meldung absenden" enden. */
    if (FLOW.kind === 'triage') return 'start';
    if (stepId === 'start') return 'start';
    if (stepId === 'fertig') return S.result ? 'fertig' : (S.session ? 'ident' : 'start');
    if (stepId === 'ident') return 'ident';
    if (!S.session) return 'ident';
    var idx = stepIndex(stepId);
    if (idx === -1) return 'ident';
    /* Foto-Pflicht (29.09.2026): Ein Pflicht-Upload laesst sich auch per
       Deep-Link/Zurueck-Vor nicht ueberspringen — ohne Foto/Video geht es
       zurueck zum Upload-Schritt. */
    if (!S.media.length) {
      var list = activeSteps();
      for (var i = 0; i < idx; i++) {
        if (list[i].kind === 'upload' && list[i].required) return list[i].id;
      }
    }
    return stepId;
  }

  /* ============================================================
     Bausteine
     ============================================================ */

  function progress(stepId) {
    var list = activeSteps();
    var idx = stepIndex(stepId);
    if (idx < 0) return null;
    var nav = el('nav', 'skf-progress');
    nav.setAttribute('aria-label', t('ui_progress_label'));
    nav.appendChild(el('p', 'skf-progress__label', t('ui_step_of', { current: idx + 1, total: list.length })));
    var ol = el('ol', 'skf-progress__steps');
    /* Ab neun Schritten werden die Labels zu Stummeln ("Beste...", "Positi...")
       und wiederholen sich — dann bleiben nur die Balken plus "Schritt X von Y",
       der Text bleibt fuer Screenreader erhalten. Bis acht Schritte sind sie auf
       Tablet und Desktop gut lesbar und helfen bei der Orientierung; auf dem
       Handy blendet sie die Section generell aus (dort passt kein Label). */
    if (list.length > 8) ol.className += ' skf-progress__steps--compact';
    list.forEach(function (st, i) {
      var li = el('li', 'skf-progress__step' + (i < idx ? ' skf-progress__step--done' : (i === idx ? ' skf-progress__step--current' : '')));
      var label = st.labelKey ? t(st.labelKey) : t('step_' + st.kind);
      if (i < idx) {
        var a = el('a', 'skf-progress__step-label', label);
        a.href = urlFor(st.id);
        a.addEventListener('click', function (ev) { ev.preventDefault(); go(st.id); });
        li.appendChild(a);
      } else {
        li.appendChild(el('span', 'skf-progress__step-label', label));
        if (i === idx) li.setAttribute('aria-current', 'step');
      }
      ol.appendChild(li);
    });
    nav.appendChild(ol);
    return nav;
  }

  function backLink(stepId) {
    var prevId = prevOf(stepId);
    var a = el('a', 'skf-back');
    a.href = urlFor(prevId);
    a.appendChild(el('span', null, '←'));
    a.appendChild(document.createTextNode(' ' + t('ui_back')));
    a.addEventListener('click', function (ev) { ev.preventDefault(); go(prevId); });
    return a;
  }

  function note(kind, text) {
    if (!text) return null;
    return el('p', 'skf-note skf-note--' + kind, text);
  }

  function actions(opts) {
    var wrap = el('div', 'skf-actions');
    if (opts.backId !== null && opts.backId !== undefined) {
      var back = el('a', 'skf-btn skf-btn--ghost', t('ui_back'));
      back.href = urlFor(opts.backId);
      back.addEventListener('click', function (ev) { ev.preventDefault(); go(opts.backId); });
      wrap.appendChild(back);
    }
    var next = el('button', 'skf-btn skf-btn--primary', opts.label || t('ui_next'));
    next.type = 'button';
    next.setAttribute('data-skf-next', '');
    if (opts.disabled !== false) next.setAttribute('disabled', '');
    next.addEventListener('click', opts.onNext);
    wrap.appendChild(next);
    var hint = el('p', 'skf-actions__hint', opts.hint || t('ui_next_hint'));
    hint.setAttribute('data-skf-hint', '');
    hint.hidden = true;
    wrap.appendChild(hint);
    /* Ein disabled-Button schluckt den Klick — die Huelle faengt ihn auf und
       zeigt die Begruendung, statt den Nutzer raten zu lassen (Kit-Pattern 19).
       Wir machen das hier selbst, weil das Gating pro Schritttyp anders ist. */
    wrap.addEventListener('click', function () {
      if (next.hasAttribute('disabled')) hint.hidden = false;
      else hint.hidden = true;
    });
    if (opts.skipId) {
      var skip = el('button', 'skflow-skip', t('ui_skip'));
      skip.type = 'button';
      skip.addEventListener('click', function () { go(opts.skipId); });
      wrap.appendChild(skip);
    }
    return wrap;
  }

  function orderSummary() {
    if (!S.session || !S.session.order) return null;
    var o = S.session.order;
    var box = el('div', 'skflow-order');
    var head = el('div', 'skflow-order__head');
    head.appendChild(el('span', 'skflow-order__label', t('ui_your_order')));
    var change = el('button', 'skflow-order__change', t('ui_change_order'));
    change.type = 'button';
    change.addEventListener('click', function () { forget(true); go('ident'); });
    head.appendChild(change);
    box.appendChild(head);
    box.appendChild(el('p', 'skflow-order__num', o.orderNumber));
    var meta = [];
    if (o.orderDate) meta.push(t('ui_order_from', { date: niceDate(o.orderDate) }));
    if (o.total) meta.push(money(o.total, o.currency));
    if (meta.length) box.appendChild(el('p', 'skflow-order__meta', meta.join(' · ')));
    return box;
  }

  function contactBlock() {
    var box = el('aside', 'skflow-help');
    box.appendChild(el('h2', 'skflow-help__title', t('ui_help_title')));
    box.appendChild(el('p', 'skflow-help__text', t('ui_help_text')));
    var row = el('div', 'skflow-help__row');
    var a1 = el('a', 'skf-btn skf-btn--ghost', t('ui_help_contact'));
    a1.href = CFG.contactUrl || '/pages/kontakt';
    row.appendChild(a1);
    box.appendChild(row);
    return box;
  }

  function otherCasesLink() {
    var a = el('a', 'skflow-other', t('ui_other_case'));
    a.href = CFG.helpUrl || '/pages/hilfe';
    return a;
  }

  function shell(stepId, nodes) {
    clear(app);
    var wrap = el('div', 'skf skflow');
    var p = progress(stepId);
    if (p) wrap.appendChild(p);
    /* Storno <-> Widerruf umgeleitet? Auf jedem Schritt ehrlich sagen. */
    var sw = flowSwitchNote();
    if (sw) wrap.appendChild(sw);
    /* Stoppbarkeit: pfadabhaengig, und bei geteilter Bestellung ehrlich
       aufgeschluesselt ("Nuetzlinge stoppbar, Lagerware nicht mehr"). */
    if (FLOW.id === 'storno' || FLOW.id === 'retoure') {
      var sp = stopabilitySplitNote() || stopabilityNote();
      if (sp) wrap.appendChild(sp);
    }
    if (stepId !== 'ident' && stepId !== 'start' && stepId !== 'fertig') wrap.appendChild(backLink(stepId));
    nodes.forEach(function (n) { if (n) wrap.appendChild(n); });
    if (stepId !== 'fertig') {
      var os = orderSummary();
      if (os) wrap.appendChild(os);
    }
    wrap.appendChild(contactBlock());
    wrap.appendChild(otherCasesLink());
    app.appendChild(wrap);
    if (window.SKFlowKit && window.SKFlowKit.boot) window.SKFlowKit.boot(app);
  }

  function card(titleText, subText, eyebrowText) {
    var c = el('div', 'skf-card');
    if (eyebrowText) c.appendChild(el('p', 'skf-card__eyebrow', eyebrowText));
    if (titleText) {
      var h = el('h2', 'skf-card__title', titleText);
      h.id = 'skflow-q';
      c.appendChild(h);
    }
    if (subText) c.appendChild(el('p', 'skf-card__text', subText));
    return c;
  }

  function loading(target) {
    clear(target);
    var box = el('div', 'skf-loading');
    box.setAttribute('aria-busy', 'true');
    box.setAttribute('aria-live', 'polite');
    ['skf-skel--title', 'skf-skel--line', 'skf-skel--line-short', 'skf-skel--card'].forEach(function (c) {
      box.appendChild(el('span', 'skf-skel ' + c));
    });
    var p = el('p', 'skf-loading__text');
    p.appendChild(el('span', 'skf-spinner'));
    p.appendChild(document.createTextNode(' ' + t('ui_loading')));
    box.appendChild(p);
    target.appendChild(box);
  }

  function errorNote(text) {
    var p = el('p', 'skf-note skf-note--warn skflow-error', text);
    p.setAttribute('role', 'alert');
    return p;
  }

  /* ============================================================
     Schritt: Identifikation
     ============================================================ */

  /* Login-Ueberholspur: kommt aus help-flow.liquid nur fuer angemeldete
     Shop-Kunden ({ email, orders: [{ ref, name, date, status, items }] }).
     Die Konto-E-Mail ist der Zweitfaktor — das ERP wertet einen E-Mail-Treffer
     als Stufe 2, der Kunde tippt weder PLZ noch Nachname. */
  var CUST = CFG.customer && CFG.customer.email ? CFG.customer : null;
  /* "Andere Bestellnummer eingeben" gewaehlt — nur fuer diese Seitenansicht. */
  var identManual = false;
  /* Ein automatischer Versuch pro Bestellnummer und Browser-Sitzung. Sonst
     wuerde jeder Reload nach einem Fehlschlag erneut ans ERP gehen und das
     Sitzungs-Limit (5/IP/Stunde) aufbrauchen, ohne dass der Kunde etwas tut. */
  var AUTO_KEY = 'skflow:autoident';

  function autoTried(ref) {
    try { return (sessionStorage.getItem(AUTO_KEY) || '').split('|').indexOf(ref) !== -1; }
    catch (e) { return false; }
  }
  function markAutoTried(ref) {
    try {
      var cur = (sessionStorage.getItem(AUTO_KEY) || '').split('|').filter(Boolean);
      if (cur.indexOf(ref) === -1) cur.push(ref);
      sessionStorage.setItem(AUTO_KEY, cur.join('|'));
    } catch (e) { /* ohne Storage: kein Schutz, aber auch kein Absturz */ }
  }

  /* Sitzung anlegen — EIN Weg fuer Formular, Bestell-Auswahl und Auto-Ident. */
  function startSession(body) {
    if (CUST && !body.email && !/@/.test(body.orderRef)) body.email = CUST.email;
    if (/@/.test(body.orderRef)) body.email = body.orderRef;
    body.locale = CFG.locale || 'de';
    return api('/self-service/sessions', { method: 'POST', body: body, auth: false })
      .then(function (data) {
        S.session = {
          id: data.sessionId, token: data.sessionToken,
          level: data.verificationLevel, channel: data.channel,
          order: data.order, tracking: data.tracking,
          canUpgrade: data.canUpgrade, upgradeTarget: data.upgradeTarget,
          /* Pfadabhaengige Stoppbarkeit (ERP deploy-16) — Strukturdaten,
             die Saetze baut diese Datei lokalisiert. */
          stopability: data.stopability || null,
          products: data.products || []
        };
        S.answers = {};
        S.media = []; S.files = [];
        persist();
        /* Jetzt ist der Versandstatus bekannt — ggf. Storno <-> Widerruf
           umleiten, BEVOR die Schrittliste gebaut wird. */
        applyFlowSwitch();
        var list = activeSteps();
        go(list.length > 2 ? list[1].id : 'pruefen');
      });
  }

  function renderIdent() {
    /* Sitzung ist flow-UEBERGREIFEND: Wer schon identifiziert ist, wird nicht
       noch einmal nach Bestellnummer/PLZ gefragt, nur weil er den Fall
       gewechselt hat. Direkt zum ersten Inhaltsschritt springen — ausser der
       ?ref=-Prefill nennt eine ANDERE Bestellung als die der Sitzung. */
    if (S.session) {
      var pre0 = prefillRef();
      var cur0 = String((S.session.order && S.session.order.orderNumber) || '').replace(/^#/, '');
      var same0 = !pre0 || pre0.replace(/^#/, '') === cur0;
      var list0 = activeSteps();
      if (same0 && list0.length > 1) { go(list0[1].id, true); return; }
    }

    /* Angemeldet: (a) Bestellung per ?ref= aus dem Hilfe-Center angeklickt →
       direkt laden, der Klick WAR die Auswahl; (b) ohne ?ref= → eigene
       Bestellungen zur Auswahl statt eines leeren Feldes. */
    if (CUST && !identManual) {
      var preC = prefillRef();
      if (preC && !autoTried(preC)) { renderAutoIdent(preC); return; }
      if (!preC && CUST.orders && CUST.orders.length) { renderPick(); return; }
    }
    renderIdentForm(null);
  }

  /* Auto-Ident: Bestellnummer + Konto-E-Mail, ohne Formular. Scheitert es
     (Bestellung lief unter anderer E-Mail, Marktplatz-Proxy-Adresse), faellt
     die Seite auf das normale Formular MIT Fehlertext und Vorbelegung zurueck. */
  function renderAutoIdent(ref) {
    var c = card(t('ident_title'), null);
    var box = el('div');
    loading(box);
    var p = box.querySelector('.skf-loading__text');
    if (p) { clear(p); p.appendChild(el('span', 'skf-spinner')); p.appendChild(document.createTextNode(' ' + t('ident_auto_loading'))); }
    c.appendChild(box);
    shell('ident', [c]);
    markAutoTried(ref);
    S.busy = true;
    startSession({ orderRef: ref })
      .then(function () { S.busy = false; })
      .catch(function (err) {
        S.busy = false;
        renderIdentForm(messageForError(err));
      });
  }

  /* Bestell-Auswahl fuer angemeldete Kunden. */
  function renderPick() {
    var c = card(t('ident_pick_title'), t('ident_pick_text', { email: CUST.email }));
    var errBox = el('div', 'skflow-errbox');
    var list = el('div', 'skflow-options skflow-pick');
    CUST.orders.forEach(function (o) {
      var b = el('button', 'skflow-option skflow-pick__item');
      b.type = 'button';
      var head = el('span', 'skflow-pick__head');
      head.appendChild(el('span', 'skflow-pick__name', o.name || ('#' + o.ref)));
      if (o.date) head.appendChild(el('span', 'skflow-pick__date', o.date));
      if (o.status) head.appendChild(el('span', 'skflow-pick__status', o.status));
      b.appendChild(head);
      if (o.items) b.appendChild(el('span', 'skflow-pick__items', o.items));
      b.addEventListener('click', function () {
        if (S.busy) return;
        S.busy = true;
        clear(errBox);
        list.querySelectorAll('button').forEach(function (x) { x.setAttribute('disabled', ''); });
        b.classList.add('skflow-option--busy');
        startSession({ orderRef: o.ref })
          .then(function () { S.busy = false; })
          .catch(function (err) {
            S.busy = false;
            list.querySelectorAll('button').forEach(function (x) { x.removeAttribute('disabled'); });
            b.classList.remove('skflow-option--busy');
            errBox.appendChild(errorNote(messageForError(err)));
          });
      });
      list.appendChild(b);
    });
    c.appendChild(list);
    c.appendChild(errBox);

    var other = el('button', 'skflow-skip skflow-pick__other', t('ident_pick_other'));
    other.type = 'button';
    other.addEventListener('click', function () { identManual = true; renderIdentForm(null); });
    c.appendChild(other);

    shell('ident', [c]);
  }

  /* Das klassische Formular. errText: Fehler eines vorherigen Auto-Versuchs. */
  function renderIdentForm(errText) {
    var c = card(t('ident_title'), t('ident_text'));
    var form = el('div', 'skflow-form');

    function field(id, labelText, helpText, type, extra) {
      var f = el('div', 'skflow-field');
      var lab = el('label', 'skflow-field__label', labelText);
      lab.setAttribute('for', id);
      f.appendChild(lab);
      var inp = el('input', 'skflow-field__input');
      inp.type = type || 'text';
      inp.id = id;
      inp.autocomplete = extra && extra.autocomplete ? extra.autocomplete : 'off';
      if (extra && extra.inputmode) inp.setAttribute('inputmode', extra.inputmode);
      if (extra && extra.required) inp.setAttribute('data-skf-required', '');
      f.appendChild(inp);
      if (helpText) f.appendChild(el('p', 'skflow-field__help', helpText));
      return { wrap: f, input: inp };
    }

    var ref = field('skflow-ref', t('ident_ref_label'), t('ident_ref_help'), 'text', { required: true, autocomplete: 'off' });
    var pre = prefillRef();
    if (pre) ref.input.value = pre;
    form.appendChild(ref.wrap);

    var chips = el('ul', 'skflow-chips');
    (CFG.refExamples || []).forEach(function (ex) { chips.appendChild(el('li', 'skflow-chip', ex)); });
    if (chips.childNodes.length) {
      form.appendChild(el('p', 'skflow-chips__label', t('ident_examples')));
      form.appendChild(chips);
    }

    var needBoth = FLOW.level >= 2;
    var zip = field('skflow-zip', t('ident_zip_label'), null, 'text',
      { inputmode: 'numeric', autocomplete: 'postal-code', required: needBoth && !CUST });
    var name = field('skflow-name', t('ident_name_label'), null, 'text',
      { autocomplete: 'family-name', required: needBoth && !CUST });
    var pair = el('div', 'skflow-pair');
    pair.appendChild(zip.wrap);
    pair.appendChild(name.wrap);
    form.appendChild(pair);
    var hintText = CUST ? t('ident_hint_loggedin', { email: CUST.email }) : (needBoth ? t('ident_hint_both') : t('ident_hint_one'));
    form.appendChild(el('p', 'skflow-field__help', hintText));

    var errBox = el('div', 'skflow-errbox');
    if (errText) errBox.appendChild(errorNote(errText));
    form.appendChild(errBox);

    var act = actions({
      backId: 'start',
      label: t('ident_submit'),
      /* Nicht denselben Satz wie die Feldhilfe wiederholen — sonst steht er
         zweimal untereinander und sagt beim zweiten Mal nichts Neues. */
      hint: t('ident_missing'),
      onNext: function () { submitIdent(); }
    });
    form.appendChild(act);
    c.appendChild(form);

    /* Ohne beide Faktoren geht L2 nicht — der Weiter-Button bleibt sonst zu.
       L1-Flows lassen PLZ ODER Nachname genuegen. Angemeldet reicht die
       Nummer: die Konto-E-Mail geht als Zweitfaktor mit. */
    var sync = function () {
      var btn = act.querySelector('[data-skf-next]');
      var hasRef = !!ref.input.value.trim();
      var z2 = !!zip.input.value.trim(), n2 = !!name.input.value.trim();
      var ok = hasRef && (CUST ? true : (needBoth ? (z2 && n2) : (z2 || n2)));
      if (ok) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
    };
    form.addEventListener('input', sync);
    window.setTimeout(sync, 0);

    form.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target && ev.target.tagName === 'INPUT') {
        ev.preventDefault();
        var btn = act.querySelector('[data-skf-next]');
        if (btn && !btn.hasAttribute('disabled')) btn.click();
      }
    });

    function submitIdent() {
      if (S.busy) return;
      S.busy = true;
      clear(errBox);
      var btn = act.querySelector('[data-skf-next]');
      btn.setAttribute('disabled', '');
      btn.textContent = t('ui_loading');
      var body = { orderRef: ref.input.value.trim() };
      var z = zip.input.value.trim(), n = name.input.value.trim();
      if (z) body.zip = z;
      if (n) body.lastName = n;
      startSession(body)
        .then(function () { S.busy = false; })
        .catch(function (err) {
          S.busy = false;
          btn.textContent = t('ident_submit');
          btn.removeAttribute('disabled');
          errBox.appendChild(errorNote(messageForError(err)));
          if (err.code === 'channel_unsupported') {
            var hint = note('info', t('err_channel_amazon_hint'));
            if (hint) errBox.appendChild(hint);
          }
        });
    }

    var noref = el('details', 'skflow-noref');
    noref.appendChild(el('summary', 'skflow-noref__q', t('ident_noref_title')));
    noref.appendChild(el('p', 'skflow-noref__a', t('ident_noref_text')));
    var nrLink = el('a', 'skf-btn skf-btn--ghost', t('ui_help_contact'));
    nrLink.href = CFG.contactUrl || '/pages/kontakt';
    noref.appendChild(nrLink);

    var nodes = [c, noref];
    if (CUST && CUST.orders && CUST.orders.length && identManual) {
      var back = el('button', 'skflow-skip skflow-pick__other', t('ident_pick_title'));
      back.type = 'button';
      back.addEventListener('click', function () { identManual = false; renderPick(); });
      nodes.splice(1, 0, back);
    }
    shell('ident', nodes);
  }

  /* ============================================================
     Schritt-Renderer nach Typ
     ============================================================ */

  function renderRadio(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null, step.eyebrowKey ? t(step.eyebrowKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var group = el('div', 'skf-options');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-labelledby', 'skflow-q');
    var chosen = S.answers[step.key];
    step.options.forEach(function (opt, i) {
      var lab = el('label', 'skf-option');
      var inp = el('input', 'skf-option__input');
      inp.type = 'radio';
      inp.name = step.key;
      inp.value = opt.value;
      if (step.required !== false) inp.setAttribute('data-skf-required', '');
      if (chosen === opt.value) inp.checked = true;
      lab.appendChild(inp);
      lab.appendChild(el('span', 'skf-option__mark'));
      var body = el('span', 'skf-option__body');
      body.appendChild(el('span', 'skf-option__title', t(opt.titleKey)));
      if (opt.textKey) body.appendChild(el('span', 'skf-option__text', t(opt.textKey)));
      lab.appendChild(body);
      group.appendChild(lab);
      inp.addEventListener('change', function () { S.answers[step.key] = opt.value; persist(); sync(); });
      /* chosen MIT aktualisieren — sonst rendert der Schritt trotz Vorauswahl
         mit gesperrtem "Weiter" (disabled wird aus chosen berechnet). */
      if (i === 0 && !chosen && step.preselectFirst) { inp.checked = true; chosen = opt.value; S.answers[step.key] = opt.value; }
    });
    form.appendChild(group);
    var optional = step.required === false;
    var act = actions({
      backId: prevOf(step.id),
      onNext: function () { advance(step); },
      /* Optionale Fragen blockieren nie — sonst ist "optional" eine Luege. */
      disabled: optional ? false : !chosen,
      hint: step.hintKey ? t(step.hintKey) : t('ui_next_hint')
    });
    form.appendChild(act);
    /* ⛔ Regression 2026-08: "Weiter" wurde nur beim Rendern berechnet und nach
       der Auswahl nie entsperrt — jede Pflicht-Radiofrage war eine Sackgasse
       ("Der Button geht nicht"). sync() muss bei JEDER Auswahl laufen. */
    function sync() {
      var btn = act.querySelector('[data-skf-next]');
      var hint = act.querySelector('[data-skf-hint]');
      if (!btn) return;
      if (optional || group.querySelector('input:checked')) {
        btn.removeAttribute('disabled');
        if (hint) hint.hidden = true;
      } else {
        btn.setAttribute('disabled', '');
      }
    }
    if (optional) {
      var lbl = c.querySelector('.skf-card__title');
      if (lbl) lbl.appendChild(el('span', 'skflow-optional', ' (' + t('ui_optional') + ')'));
    }
    c.appendChild(form);
    shell(step.id, [c]);
  }

  function renderCheckgroup(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var list = el('div', 'skf-options');
    var chosen = Array.isArray(S.answers[step.key]) ? S.answers[step.key].slice() : [];
    step.options.forEach(function (opt) {
      var lab = el('label', 'skf-option');
      var inp = el('input', 'skf-option__input');
      inp.type = 'checkbox';
      inp.name = step.key;
      inp.value = opt.value;
      if (chosen.indexOf(opt.value) !== -1) inp.checked = true;
      lab.appendChild(inp);
      lab.appendChild(el('span', 'skf-option__mark'));
      var body = el('span', 'skf-option__body');
      body.appendChild(el('span', 'skf-option__title', t(opt.titleKey)));
      if (opt.textKey) body.appendChild(el('span', 'skf-option__text', t(opt.textKey)));
      lab.appendChild(body);
      list.appendChild(lab);
      inp.addEventListener('change', function () {
        var pos = chosen.indexOf(opt.value);
        if (inp.checked && pos === -1) chosen.push(opt.value);
        if (!inp.checked && pos !== -1) chosen.splice(pos, 1);
        S.answers[step.key] = chosen.slice();
        persist();
        sync();
      });
    });
    form.appendChild(list);
    var act = actions({
      backId: prevOf(step.id),
      hint: step.hintKey ? t(step.hintKey) : t('ui_next_hint'),
      onNext: function () { advance(step); }
    });
    form.appendChild(act);
    c.appendChild(form);

    function sync() {
      var btn = act.querySelector('[data-skf-next]');
      var need = step.requireAll ? step.options.length : (step.min || 1);
      if (chosen.length >= need) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
    }
    window.setTimeout(sync, 0);
    shell(step.id, [c]);
  }

  function renderConsent(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var lab = el('label', 'skf-option');
    var inp = el('input', 'skf-option__input');
    inp.type = 'checkbox';
    inp.name = step.key;
    inp.setAttribute('data-skf-required', '');
    if (S.answers[step.key]) inp.checked = true;
    lab.appendChild(inp);
    lab.appendChild(el('span', 'skf-option__mark'));
    var body = el('span', 'skf-option__body');
    body.appendChild(el('span', 'skf-option__title', t(step.consentKey)));
    if (step.consentTextKey) body.appendChild(el('span', 'skf-option__text', t(step.consentTextKey)));
    lab.appendChild(body);
    form.appendChild(lab);
    inp.addEventListener('change', function () { S.answers[step.key] = inp.checked; persist(); sync(); });
    var act = actions({
      backId: prevOf(step.id),
      hint: step.hintKey ? t(step.hintKey) : t('ui_next_hint'),
      onNext: function () { advance(step); },
      disabled: !S.answers[step.key]
    });
    form.appendChild(act);
    /* Gleiches Muster wie renderRadio: Haken setzen muss "Weiter" entsperren. */
    function sync() {
      var btn = act.querySelector('[data-skf-next]');
      var hint = act.querySelector('[data-skf-hint]');
      if (!btn) return;
      if (inp.checked) {
        btn.removeAttribute('disabled');
        if (hint) hint.hidden = true;
      } else {
        btn.setAttribute('disabled', '');
      }
    }
    c.appendChild(form);
    shell(step.id, [c]);
  }

  function orderItems() {
    if (!S.session || !S.session.order || !S.session.order.items) return [];
    return S.session.order.items;
  }

  function renderItems(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var items = orderItems();
    var form = el('div', 'skflow-form');

    if (!items.length) {
      var empty = el('div', 'skf-empty');
      empty.appendChild(el('p', 'skf-empty__title', t('items_empty_title')));
      empty.appendChild(el('p', 'skf-empty__text', t('items_empty_text')));
      form.appendChild(empty);
      form.appendChild(actions({ backId: prevOf(step.id), onNext: function () { advance(step); }, disabled: false }));
      c.appendChild(form);
      shell(step.id, [c]);
      return;
    }

    var chosen = Array.isArray(S.answers[step.key]) ? S.answers[step.key].slice() : [];
    function find(sku) { for (var i = 0; i < chosen.length; i++) if (chosen[i].sku === sku) return chosen[i]; return null; }

    var ul = el('ul', 'skf-items');
    ul.setAttribute('role', 'list');
    items.forEach(function (it, idx) {
      var sku = it.sku || ('pos-' + idx);
      var li = el('li', 'skf-item');
      var pick = el('label', 'skf-item__pick');
      var box = el('input', 'skf-item__input');
      box.type = 'checkbox';
      box.value = sku;
      var pre = find(sku);
      if (pre) box.checked = true;
      pick.appendChild(box);
      pick.appendChild(el('span', 'skf-item__mark'));
      li.appendChild(pick);
      li.appendChild(el('span', 'skf-item__thumb'));
      var body = el('div', 'skf-item__body');
      body.appendChild(el('p', 'skf-item__title', it.title || sku));
      var meta = [];
      if (it.sku) meta.push(t('items_sku', { sku: it.sku }));
      meta.push(t('items_ordered', { qty: it.quantity }));
      body.appendChild(el('p', 'skf-item__meta', meta.join(' · ')));
      li.appendChild(body);

      var qtyBox = null, qtyInput = null;
      if (step.withQty) {
        qtyBox = el('div', 'skf-qty');
        qtyBox.setAttribute('data-skf-qty', '');
        var dec = el('button', 'skf-qty__btn', '−');
        dec.type = 'button';
        dec.setAttribute('data-skf-qty-dec', '');
        dec.setAttribute('aria-label', t('ui_qty_less'));
        qtyInput = el('input', 'skf-qty__input');
        qtyInput.type = 'number';
        qtyInput.min = '1';
        qtyInput.max = String(it.quantity || 1);
        qtyInput.value = String(pre ? pre.quantity : 1);
        qtyInput.setAttribute('inputmode', 'numeric');
        qtyInput.setAttribute('aria-label', t('ui_qty_label'));
        var inc = el('button', 'skf-qty__btn', '+');
        inc.type = 'button';
        inc.setAttribute('data-skf-qty-inc', '');
        inc.setAttribute('aria-label', t('ui_qty_more'));
        qtyBox.appendChild(dec); qtyBox.appendChild(qtyInput); qtyBox.appendChild(inc);
        li.appendChild(qtyBox);
      }

      function push() {
        var pos = -1;
        for (var i = 0; i < chosen.length; i++) if (chosen[i].sku === sku) pos = i;
        if (box.checked) {
          var entry = {
            sku: it.sku || null, lineItemId: it.id || it.lineItemId || null,
            title: it.title || null,
            quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : (it.quantity || 1),
            ordered: it.quantity || 1
          };
          /* Mehrfachpack („2 x 500 ml"): Packungsgroesse mitschicken — der
             Schadens-Flow fragt danach, wie viele Flaschen/Stueck betroffen
             sind (Fall SK-2026-10-AC3Q). */
          if (it.packUnits && it.packUnits > 1) {
            entry.packUnits = it.packUnits;
            if (it.variantLabel) entry.variantLabel = it.variantLabel;
          }
          if (pos === -1) chosen.push(entry); else chosen[pos] = entry;
        } else if (pos !== -1) { chosen.splice(pos, 1); }
        S.answers[step.key] = chosen.slice();
        persist();
        sync();
      }
      box.addEventListener('change', push);
      if (qtyInput) qtyInput.addEventListener('change', push);
      ul.appendChild(li);
    });
    form.appendChild(ul);

    var act = actions({
      backId: prevOf(step.id),
      hint: step.hintKey ? t(step.hintKey) : t('items_hint'),
      onNext: function () { advance(step); }
    });
    form.appendChild(act);
    c.appendChild(form);

    function sync() {
      var btn = act.querySelector('[data-skf-next]');
      if (chosen.length >= 1) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
    }
    window.setTimeout(sync, 0);
    shell(step.id, [c]);
  }

  function totalUnits() {
    var picked = S.answers.affectedItems;
    if (Array.isArray(picked) && picked.length) {
      return picked.reduce(function (a, b) { return a + (b.ordered || b.quantity || 1); }, 0);
    }
    return orderItems().reduce(function (a, b) { return a + (b.quantity || 1); }, 0) || 1;
  }

  /* Gewaehlte Positionen, die Mehrfachpacks sind (packUnits > 1). */
  function packSelections() {
    var picked = S.answers.affectedItems;
    if (!Array.isArray(picked)) return [];
    return picked.filter(function (p) { return p && p.packUnits && p.packUnits > 1; });
  }

  /* Mehrfachpack: Wie viele Flaschen/Stueck sind betroffen? Ein Zaehler je
     gewaehlter Pack-Position, Obergrenze = Packungsgroesse x gemeldete Packs.
     Schreibt affectedItems[i].affectedUnits + answers.affectedUnits/totalUnits. */
  function renderPackUnits(step) {
    var packs = packSelections();
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    var form = el('div', 'skflow-form');
    var ul = el('ul', 'skf-items');
    ul.setAttribute('role', 'list');
    function recompute() {
      var aff = 0, tot = 0;
      packSelections().forEach(function (p) {
        tot += p.packUnits * (p.quantity || 1);
        aff += p.affectedUnits || 0;
      });
      S.answers.affectedUnits = aff;
      S.answers.totalUnits = tot;
      persist();
    }
    packs.forEach(function (p) {
      var max = p.packUnits * Math.max(1, p.quantity || 1);
      if (!p.affectedUnits || p.affectedUnits > max) p.affectedUnits = 1;
      var li = el('li', 'skf-item');
      var body = el('div', 'skf-item__body');
      body.appendChild(el('p', 'skf-item__title', (p.title || p.sku || '') + (p.variantLabel ? ' · ' + p.variantLabel : '')));
      body.appendChild(el('p', 'skf-item__meta', t('be_units_of', { total: max })));
      li.appendChild(body);
      var box = el('div', 'skf-qty');
      box.setAttribute('data-skf-qty', '');
      var dec = el('button', 'skf-qty__btn', '−');
      dec.type = 'button'; dec.setAttribute('data-skf-qty-dec', ''); dec.setAttribute('aria-label', t('ui_qty_less'));
      var inp = el('input', 'skf-qty__input');
      inp.type = 'number'; inp.min = '1'; inp.max = String(max);
      inp.setAttribute('inputmode', 'numeric');
      inp.setAttribute('aria-label', t(step.titleKey));
      inp.value = String(p.affectedUnits);
      var inc = el('button', 'skf-qty__btn', '+');
      inc.type = 'button'; inc.setAttribute('data-skf-qty-inc', ''); inc.setAttribute('aria-label', t('ui_qty_more'));
      box.appendChild(dec); box.appendChild(inp); box.appendChild(inc);
      li.appendChild(box);
      function update() {
        var v = parseInt(inp.value || '1', 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > max) v = max;
        p.affectedUnits = v;
        recompute();
      }
      inp.addEventListener('change', update);
      inp.addEventListener('input', update);
      ul.appendChild(li);
    });
    form.appendChild(ul);
    recompute();
    var act = actions({ backId: prevOf(step.id), onNext: function () { recompute(); advance(step); }, disabled: false });
    form.appendChild(act);
    c.appendChild(form);
    shell(step.id, [c]);
  }

  function renderNumber(step) {
    var max = step.maxFrom === 'units' ? totalUnits() : (step.max || 99);
    var c = card(t(step.titleKey), t(step.textKey, { total: max }));
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var box = el('div', 'skf-qty skflow-qty--big');
    box.setAttribute('data-skf-qty', '');
    var dec = el('button', 'skf-qty__btn', '−');
    dec.type = 'button'; dec.setAttribute('data-skf-qty-dec', ''); dec.setAttribute('aria-label', t('ui_qty_less'));
    var inp = el('input', 'skf-qty__input');
    inp.type = 'number'; inp.min = '0'; inp.max = String(max);
    inp.setAttribute('inputmode', 'numeric');
    inp.setAttribute('aria-label', t(step.titleKey));
    inp.value = (S.answers[step.key] !== undefined && S.answers[step.key] !== null) ? String(S.answers[step.key]) : '0';
    var inc = el('button', 'skf-qty__btn', '+');
    inc.type = 'button'; inc.setAttribute('data-skf-qty-inc', ''); inc.setAttribute('aria-label', t('ui_qty_more'));
    box.appendChild(dec); box.appendChild(inp); box.appendChild(inc);
    form.appendChild(box);
    form.appendChild(el('p', 'skflow-field__help', t('units_of_total', { total: max })));
    var live = el('p', 'skflow-derived');
    form.appendChild(live);
    var warn = el('div', 'skflow-errbox');
    form.appendChild(warn);

    function update() {
      var v = parseInt(inp.value || '0', 10);
      if (isNaN(v)) v = 0;
      S.answers[step.key] = v;
      S.answers.totalUnits = max;
      S.answers.affectedUnits = Math.max(0, max - v);
      persist();
      live.textContent = t('units_derived', { affected: S.answers.affectedUnits, total: max });
      clear(warn);
      var btn = act.querySelector('[data-skf-next]');
      if (v > max) {
        warn.appendChild(errorNote(t('units_too_many', { total: max })));
        btn.setAttribute('disabled', '');
      } else if (S.answers.affectedUnits <= 0) {
        var g = note('good', t('units_none_affected'));
        if (g) warn.appendChild(g);
        btn.removeAttribute('disabled');
      } else {
        btn.removeAttribute('disabled');
      }
    }
    inp.addEventListener('change', update);
    inp.addEventListener('input', update);
    var act = actions({ backId: prevOf(step.id), onNext: function () { advance(step); }, disabled: false });
    form.appendChild(act);
    c.appendChild(form);
    window.setTimeout(update, 0);
    shell(step.id, [c]);
  }

  function renderDate(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    var form = el('div', 'skflow-form');
    var quick = el('div', 'skflow-quick');
    var today = new Date();
    function iso(d) { return d.toISOString().slice(0, 10); }
    [
      { key: 'date_today', days: 0 },
      { key: 'date_yesterday', days: 1 },
      { key: 'date_daybefore', days: 2 }
    ].forEach(function (q) {
      var b = el('button', 'skflow-quick__btn', t(q.key));
      b.type = 'button';
      b.addEventListener('click', function () {
        var d = new Date(today.getTime() - q.days * 86400000);
        inp.value = iso(d);
        update();
      });
      quick.appendChild(b);
    });
    form.appendChild(quick);
    var f = el('div', 'skflow-field');
    var lab = el('label', 'skflow-field__label', t('date_exact_label'));
    lab.setAttribute('for', 'skflow-date');
    var inp = el('input', 'skflow-field__input');
    inp.type = 'date';
    inp.id = 'skflow-date';
    inp.max = iso(today);
    if (S.answers[step.key]) inp.value = S.answers[step.key];
    f.appendChild(lab); f.appendChild(inp);
    form.appendChild(f);
    var live = el('p', 'skflow-derived');
    form.appendChild(live);

    var act = actions({ backId: prevOf(step.id), onNext: function () { advance(step); } });
    form.appendChild(act);
    c.appendChild(form);

    function update() {
      S.answers[step.key] = inp.value || null;
      persist();
      var btn = act.querySelector('[data-skf-next]');
      if (inp.value) {
        btn.removeAttribute('disabled');
        var d = daysBetween(inp.value);
        live.textContent = d !== null && d >= 0 ? t('date_days_ago', { days: d }) : '';
      } else if (step.required === false) {
        btn.removeAttribute('disabled');
        live.textContent = '';
      } else {
        btn.setAttribute('disabled', '');
        live.textContent = '';
      }
    }
    inp.addEventListener('change', update);
    window.setTimeout(update, 0);
    shell(step.id, [c]);
  }

  function renderText(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var f = el('div', 'skflow-field');
    var lab = el('label', 'skflow-field__label',
      t(step.labelKey || step.titleKey) + (step.required === false ? ' (' + t('ui_optional') + ')' : ''));
    lab.setAttribute('for', 'skflow-text-' + step.key);
    var ta = el('textarea', 'skf-upload__textarea');
    ta.id = 'skflow-text-' + step.key;
    ta.rows = step.rows || 4;
    ta.maxLength = step.maxLength || 1000;
    if (S.answers[step.key]) ta.value = S.answers[step.key];
    f.appendChild(lab); f.appendChild(ta);
    if (step.helpKey) f.appendChild(el('p', 'skflow-field__help', t(step.helpKey)));
    form.appendChild(f);
    var act = actions({ backId: prevOf(step.id), onNext: function () { advance(step); }, disabled: step.required === false ? false : !S.answers[step.key] });
    form.appendChild(act);
    c.appendChild(form);
    ta.addEventListener('input', function () {
      S.answers[step.key] = ta.value;
      persist();
      if (step.required !== false) {
        var btn = act.querySelector('[data-skf-next]');
        if (ta.value.trim()) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
      }
    });
    shell(step.id, [c]);
  }

  function renderFields(step) {
    var c = card(t(step.titleKey), step.textKey ? t(step.textKey) : null);
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });
    var form = el('div', 'skflow-form');
    var store = S.answers[step.key] || {};
    var inputs = [];
    step.fields.forEach(function (fd) {
      var f = el('div', 'skflow-field' + (fd.half ? ' skflow-field--half' : ''));
      var lab = el('label', 'skflow-field__label', t(fd.labelKey) + (fd.required === false ? ' (' + t('ui_optional') + ')' : ''));
      lab.setAttribute('for', 'skflow-f-' + fd.key);
      var inp = el('input', 'skflow-field__input');
      inp.type = 'text';
      inp.id = 'skflow-f-' + fd.key;
      if (fd.autocomplete) inp.autocomplete = fd.autocomplete;
      if (fd.inputmode) inp.setAttribute('inputmode', fd.inputmode);
      if (store[fd.key]) inp.value = store[fd.key];
      f.appendChild(lab); f.appendChild(inp);
      if (fd.helpKey) f.appendChild(el('p', 'skflow-field__help', t(fd.helpKey)));
      form.appendChild(f);
      inputs.push({ def: fd, input: inp });
    });
    var warn = el('div', 'skflow-errbox');
    form.appendChild(warn);
    var act = actions({ backId: prevOf(step.id), onNext: function () { advance(step); } });
    form.appendChild(act);
    c.appendChild(form);

    function sync() {
      var obj = {};
      inputs.forEach(function (o) { obj[o.def.key] = o.input.value.trim(); });
      S.answers[step.key] = obj;
      persist();
      clear(warn);
      var ok = inputs.every(function (o) { return o.def.required === false || !!o.input.value.trim(); });
      /* Hausnummern-Pruefung: doppelte Hausnummer ist der haeufigste reale Fehler. */
      if (step.checkStreet && obj.street) {
        var m = /(\d+\s*[a-zA-Z]?)\s+\1\b/.exec(obj.street);
        var hasNumber = /\d/.test(obj.street);
        if (m) { var w = note('warn', t('address_double_house_number')); if (w) warn.appendChild(w); }
        if (!hasNumber) { var w2 = note('warn', t('address_missing_house_number')); if (w2) warn.appendChild(w2); }
      }
      var btn = act.querySelector('[data-skf-next]');
      if (ok) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
    }
    form.addEventListener('input', sync);
    window.setTimeout(sync, 0);
    shell(step.id, [c]);
  }

  /* --- Vitaltest: der Zwischenschritt, der Meldungen ueberfluessig macht --- */
  function renderVital(step) {
    var c = card(t(step.titleKey), t(step.textKey), t('vital_eyebrow'));
    var g = note('good', t('vital_deflection'));
    if (g) c.appendChild(g);

    (step.panels || []).forEach(function (p, i) {
      var d = el('details', 'skflow-vital');
      if (i === 0) d.open = true;
      d.appendChild(el('summary', 'skflow-vital__q', t(p.titleKey)));
      var body = el('div', 'skflow-vital__a');
      (p.stepsKeys || []).forEach(function (k, n) {
        var row = el('div', 'skflow-vital__step');
        row.appendChild(el('span', 'skflow-vital__num', String(n + 1)));
        row.appendChild(el('p', 'skflow-vital__text', t(k)));
        body.appendChild(row);
      });
      var res = el('ul', 'skflow-vital__res');
      if (p.aliveKey) {
        var li1 = el('li', 'skflow-vital__res-item skflow-vital__res-item--alive');
        li1.appendChild(el('span', 'skflow-vital__res-ic', '✓'));
        li1.appendChild(el('span', null, t(p.aliveKey)));
        res.appendChild(li1);
      }
      if (p.deadKey) {
        var li2 = el('li', 'skflow-vital__res-item skflow-vital__res-item--dead');
        li2.appendChild(el('span', 'skflow-vital__res-ic', '✗'));
        li2.appendChild(el('span', null, t(p.deadKey)));
        res.appendChild(li2);
      }
      if (res.childNodes.length) body.appendChild(res);
      if (p.warnKey) { var w = note('warn', t(p.warnKey)); if (w) body.appendChild(w); }
      d.appendChild(body);
      c.appendChild(d);
    });

    var wrap = el('div', 'skf-actions');
    var out = el('a', 'skf-btn skf-btn--ghost', t('vital_exit'));
    out.href = CFG.helpUrl || '/pages/hilfe';
    out.addEventListener('click', function () { forget(); });
    wrap.appendChild(out);
    var cont = el('button', 'skf-btn skf-btn--primary', t('vital_continue'));
    cont.type = 'button';
    cont.addEventListener('click', function () { S.answers.vitalCheckDone = true; persist(); advance(step); });
    wrap.appendChild(cont);
    c.appendChild(wrap);
    shell(step.id, [c]);
  }

  /* --- Upload --- */
  function renderUpload(step) {
    var c = card(t(step.titleKey), t(step.textKey));
    step.notes && step.notes.forEach(function (nn) { var x = note(nn.kind, t(nn.key)); if (x) c.appendChild(x); });

    var box = el('div', 'skf-upload');
    box.setAttribute('data-skf-upload', '');
    box.setAttribute('data-skf-max-files', String(step.maxFiles || 8));
    box.setAttribute('data-skf-max-mb', String(step.maxMb || 100));

    if (step.exampleKeys && step.exampleKeys.length) {
      var ol = el('ol', 'skf-upload__examples');
      step.exampleKeys.forEach(function (k, i) {
        var li = el('li', 'skf-upload__example');
        var fig = el('figure', 'skf-upload__example-media');
        fig.setAttribute('itemscope', '');
        fig.setAttribute('itemtype', 'https://schema.org/ImageObject');
        fig.appendChild(el('span', 'skf-upload__example-num'));
        fig.appendChild(exampleSvg(i));
        var meta = document.createElement('meta');
        meta.setAttribute('itemprop', 'name');
        meta.setAttribute('content', t(k));
        fig.appendChild(meta);
        li.appendChild(fig);
        li.appendChild(el('p', 'skf-upload__example-caption', t(k)));
        ol.appendChild(li);
      });
      box.appendChild(ol);
    }

    var zone = el('div', 'skf-upload__zone');
    var input = el('input', 'skf-upload__input');
    input.type = 'file';
    input.name = 'media[]';
    input.multiple = true;
    input.accept = 'image/*,video/*';
    input.setAttribute('aria-label', t('upload_drop'));
    zone.appendChild(input);
    zone.appendChild(el('span', 'skf-upload__plus', '+'));
    zone.appendChild(el('p', 'skf-upload__zone-title', t('upload_drop')));
    zone.appendChild(el('p', 'skf-upload__zone-text', t('upload_drop_sub')));
    zone.appendChild(el('p', 'skf-upload__limits', t('upload_limits')));
    box.appendChild(zone);
    box.appendChild(el('ul', 'skf-upload__thumbs'));
    var msg = el('p', 'skf-upload__msg');
    msg.hidden = true;
    box.appendChild(msg);
    c.appendChild(box);

    var already = el('p', 'skflow-derived');
    if (S.media.length) already.textContent = t('upload_already', { count: S.media.length });
    c.appendChild(already);

    var bar = el('div', 'skflow-progress');
    bar.hidden = true;
    var fill = el('span', 'skflow-progress__fill');
    bar.appendChild(fill);
    c.appendChild(bar);
    var errBox = el('div', 'skflow-errbox');
    c.appendChild(errBox);

    var required = !!step.required;
    var act = actions({
      backId: prevOf(step.id),
      hint: t('upload_required_hint'),
      disabled: required && !S.media.length,
      onNext: function () { doUpload(); }
    });
    if (!required) {
      var skip = el('button', 'skflow-skip', t('upload_skip'));
      skip.type = 'button';
      skip.addEventListener('click', function () { advance(step); });
      act.appendChild(skip);
    }
    c.appendChild(act);

    function doUpload() {
      var list = input.files && input.files.length ? Array.prototype.slice.call(input.files) : [];
      if (!list.length) { advance(step); return; }
      if (S.busy) return;
      S.busy = true;
      clear(errBox);
      var btn = act.querySelector('[data-skf-next]');
      btn.setAttribute('disabled', '');
      btn.textContent = t('upload_uploading');
      bar.hidden = false;
      var done = 0;
      function nextFile() {
        if (done >= list.length) {
          S.busy = false;
          persist();
          advance(step);
          return;
        }
        var f = list[done];
        uploadFile(f, function (pct) {
          var overall = Math.round(((done + pct / 100) / list.length) * 100);
          fill.style.width = overall + '%';
        }).then(function (m) {
          S.media.push(m);
          done++;
          nextFile();
        }).catch(function (err) {
          S.busy = false;
          bar.hidden = true;
          btn.textContent = t('ui_next');
          btn.removeAttribute('disabled');
          errBox.appendChild(errorNote(messageForError(err)));
        });
      }
      nextFile();
    }

    input.addEventListener('change', function () {
      var btn = act.querySelector('[data-skf-next]');
      if (input.files && input.files.length) btn.removeAttribute('disabled');
      else if (required && !S.media.length) btn.setAttribute('disabled', '');
      else btn.removeAttribute('disabled');
    });

    shell(step.id, [c]);
  }

  function exampleSvg(i) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 160 120');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-hidden', 'true');
    var shapes = [
      '<rect x="0" y="0" width="160" height="120" fill="var(--sk-bg-light)"/><path d="M40 46h80v52H40z" fill="var(--sk-neutral-100)" stroke="var(--sk-primary)" stroke-width="2"/><path d="M40 46l14-14h52l14 14" fill="none" stroke="var(--sk-primary)" stroke-width="2" stroke-linejoin="round"/><path d="M80 32v66" stroke="var(--sk-neutral-300)" stroke-width="2"/><rect x="66" y="60" width="28" height="20" rx="3" fill="var(--sk-gold-light)" stroke="var(--sk-gold-hover)" stroke-width="2"/>',
      '<rect x="0" y="0" width="160" height="120" fill="var(--sk-bg-light)"/><rect x="26" y="30" width="108" height="66" rx="4" fill="var(--sk-neutral-100)" stroke="var(--sk-primary)" stroke-width="2"/><rect x="40" y="44" width="52" height="38" rx="2" fill="var(--sk-bg-white)" stroke="var(--sk-secondary)" stroke-width="2"/><path d="M46 54h40M46 62h40M46 70h26" stroke="var(--sk-neutral-300)" stroke-width="3" stroke-linecap="round"/><path d="M102 46v34M108 46v34M113 46v34M119 46v34M124 46v34" stroke="var(--sk-primary)" stroke-width="2"/>',
      '<rect x="0" y="0" width="160" height="120" fill="var(--sk-bg-white)"/><rect x="20" y="24" width="120" height="76" rx="4" fill="var(--sk-bg-light)" stroke="var(--sk-neutral-300)" stroke-width="2"/><circle cx="58" cy="52" r="5" fill="var(--sk-primary)"/><circle cx="82" cy="66" r="5" fill="var(--sk-primary)"/><circle cx="104" cy="48" r="5" fill="var(--sk-primary)"/><circle cx="70" cy="82" r="5" fill="var(--sk-primary)"/><circle cx="110" cy="78" r="5" fill="var(--sk-primary)"/><circle cx="92" cy="34" r="20" fill="none" stroke="var(--sk-gold)" stroke-width="3"/><path d="M106 48l16 16" stroke="var(--sk-gold)" stroke-width="4" stroke-linecap="round"/>',
      '<rect x="0" y="0" width="160" height="120" fill="var(--sk-bg-light)"/><rect x="30" y="34" width="100" height="58" rx="4" fill="var(--sk-neutral-100)" stroke="var(--sk-primary)" stroke-width="2"/><path d="M30 60h100" stroke="var(--sk-neutral-300)" stroke-width="2"/><path d="M52 46l16 16M68 46l-16 16" stroke="var(--sk-gold-hover)" stroke-width="3" stroke-linecap="round"/>'
    ];
    svg.innerHTML = shapes[i % shapes.length];
    return svg;
  }

  /* --- Sendungsstatus: Ergebnis statt Formular --- */
  function renderStatus(step) {
    var tr = S.session ? S.session.tracking : null;
    var o = S.session ? S.session.order : null;
    var c = card(t('status_title'), null);

    var head = el('div', 'skflow-status');
    var statusText = tr && (tr.statusText || tr.status) ? (tr.statusText || tr.status) : t('status_unknown');
    head.appendChild(el('p', 'skflow-status__badge', statusText));
    if (tr && tr.trackingNumber) {
      head.appendChild(el('p', 'skflow-status__num', t('status_tracking_number', { number: tr.trackingNumber })));
    }
    c.appendChild(head);

    /* Klartext-Prognose statt Rohstatus */
    var plain = plainForecast(tr, o);
    if (plain.text) { var pn = note(plain.kind, plain.text); if (pn) c.appendChild(pn); }

    /* Haengt die Bestellung im Abgabegespraech, ist DAS die eigentliche
       Antwort auf "wo ist mein Paket": Klartext + Link zur Rueckruf-
       Terminwahl. Nur pruefen, wenn noch nichts unterwegs ist. */
    var abHolder = el('div', 'skflow-errbox');
    c.appendChild(abHolder);
    if (!tr || !tr.events || !tr.events.length) {
      api('/self-service/sessions/' + S.session.id + '/abgabe')
        .then(function (ab) {
          if (!ab || !ab.pending) return;
          var an = note('warn', t('sd_note_abgabe'));
          if (an) abHolder.appendChild(an);
          var cta = el('a', 'skf-btn skf-btn--primary', t('ab_status_cta'));
          cta.href = (CFG.flowBase || '/pages/hilfe') + '-abgabegespraech';
          abHolder.appendChild(cta);
        })
        .catch(function () { /* Zusatzinfo — Status bleibt auch ohne sie nutzbar */ });
    }

    if (tr && tr.events && tr.events.length) {
      var ol = el('ol', 'skflow-timeline');
      tr.events.slice(0, 12).forEach(function (ev, i) {
        var li = el('li', 'skflow-timeline__item' + (i === 0 ? ' skflow-timeline__item--now' : ''));
        li.appendChild(el('span', 'skflow-timeline__dot'));
        var b = el('div', 'skflow-timeline__body');
        b.appendChild(el('p', 'skflow-timeline__desc', ev.description || ''));
        var m = [];
        if (ev.timestamp) m.push(niceDateTime(ev.timestamp));
        if (ev.location) m.push(ev.location);
        if (m.length) b.appendChild(el('p', 'skflow-timeline__meta', m.join(' · ')));
        li.appendChild(b);
        ol.appendChild(li);
      });
      c.appendChild(ol);
    } else {
      var e = el('div', 'skf-empty');
      e.appendChild(el('p', 'skf-empty__title', t('status_no_events_title')));
      e.appendChild(el('p', 'skf-empty__text', t('status_no_events_text')));
      c.appendChild(e);
      /* Briefsendungen werden nur grob gescannt — das ehrlich sagen, statt
         den Kunden raten zu lassen, ob die Sendung verschollen ist. Bei alten
         Sendungen steht das schon in der Prognose; "gib ihr vier Werktage"
         waere dann ein Widerspruch. */
      var ageWp = noScanAgeDays(o);
      if (ageWp === null || ageWp < NO_SCAN_OLD_DAYS) {
        var wp = note('info', t('sd_note_warenpost'));
        if (wp) c.appendChild(wp);
      }
    }

    if (tr && tr.trackingUrl) {
      var a = el('a', 'skf-btn skf-btn--ghost', t('status_carrier_link'));
      a.href = tr.trackingUrl;
      a.rel = 'noopener';
      a.target = '_blank';
      c.appendChild(a);
    }

    /* Ausstieg: hilft das? */
    var follow = el('div', 'skflow-followup');
    follow.appendChild(el('h3', 'skflow-followup__title', t('status_helpful_title')));
    var row = el('div', 'skflow-followup__row');
    var yes = el('a', 'skf-btn skf-btn--primary', t('status_helpful_yes'));
    yes.href = CFG.helpUrl || '/pages/hilfe';
    yes.addEventListener('click', function () { forget(); });
    row.appendChild(yes);
    var no = el('a', 'skf-btn skf-btn--ghost', t('status_helpful_no'));
    no.href = (CFG.flowBase || '/pages/hilfe') + '-paket-nicht-angekommen';
    row.appendChild(no);
    follow.appendChild(row);
    c.appendChild(follow);

    shell(step.id, [c]);
  }

  function plainForecast(tr, o) {
    var st = tr ? String(tr.status || tr.statusText || '').toLowerCase() : '';
    var stuck = tr && tr.stuckDays ? tr.stuckDays : 0;
    var ff = o ? String(o.fulfillmentStatus || '').toLowerCase() : '';
    if (!tr && ff !== 'fulfilled') return { kind: 'info', text: t('forecast_processing') };
    if (stuck >= 5) return { kind: 'warn', text: t('forecast_presumed_lost', { days: stuck }) };
    if (stuck >= 3) return { kind: 'warn', text: t('forecast_stuck', { days: stuck }) };
    if (/deliver|zugestellt/.test(st)) return { kind: 'good', text: t('forecast_delivered') };
    if (/return|rueck|rück/.test(st)) return { kind: 'warn', text: t('forecast_returned') };
    if (/transit|unterwegs|zustellung/.test(st)) return { kind: 'info', text: t('forecast_in_transit') };
    if (tr && tr.trackingNumber && (!tr.events || !tr.events.length)) {
      /* "Erster Scan kommt meist am naechsten Werktag" stimmt nur fuer frische
         Sendungen. Eine 10 Tage alte Warenpost ohne Scan braucht einen ehrlichen
         Satz und den Weg zu "Paket nicht angekommen" — kein Vertroesten. */
      var age = noScanAgeDays(o);
      if (age !== null && age >= NO_SCAN_OLD_DAYS) return { kind: 'warn', text: t('forecast_no_scan_old', { days: age }) };
      return { kind: 'info', text: t('forecast_announced') };
    }
    return { kind: 'info', text: t('forecast_unknown') };
  }

  /* Ab wann eine Sendung ohne Scan nicht mehr "frisch" ist (Kalendertage seit
     Bestellung — ein Versanddatum liefert die Session nicht). */
  var NO_SCAN_OLD_DAYS = 5;
  function noScanAgeDays(o) {
    if (!o || !o.orderDate) return null;
    var d = daysBetween(o.orderDate);
    return d === null ? null : d;
  }

  /* --- Rechnungen --- */
  function renderInvoices(step) {
    var c = card(t('invoice_title'), t('invoice_text'));
    var holder = el('div', 'skflow-invoices');
    c.appendChild(holder);
    shell(step.id, [c]);
    loading(holder);

    api('/self-service/sessions/' + S.session.id + '/invoices')
      .then(function (data) {
        S.invoices = (data && data.invoices) || [];
        clear(holder);
        if (!S.invoices.length) {
          var e = el('div', 'skf-empty');
          e.appendChild(el('p', 'skf-empty__title', t('invoice_none_title')));
          e.appendChild(el('p', 'skf-empty__text', t('invoice_none_text')));
          holder.appendChild(e);
          var cta = el('button', 'skf-btn skf-btn--primary', t('invoice_report_missing'));
          cta.type = 'button';
          cta.addEventListener('click', function () { S.answers.invoiceMissing = true; persist(); advance(step); });
          holder.appendChild(cta);
          return;
        }
        if (S.invoices.length > 1) {
          var n = note('warn', t('invoice_multiple', { count: S.invoices.length }));
          if (n) holder.appendChild(n);
        }
        var ul = el('ul', 'skflow-invoices__list');
        S.invoices.forEach(function (inv) {
          var li = el('li', 'skflow-invoice');
          var body = el('div', 'skflow-invoice__body');
          body.appendChild(el('p', 'skflow-invoice__num', t('invoice_number', { number: inv.invoiceNumber })));
          var m = [];
          if (inv.invoiceDate) m.push(niceDate(inv.invoiceDate));
          if (inv.grossAmount) m.push(money(inv.grossAmount, 'EUR'));
          body.appendChild(el('p', 'skflow-invoice__meta', m.join(' · ')));
          li.appendChild(body);
          if (inv.pdfUrl) {
            var a = el('a', 'skf-btn skf-btn--primary', t('invoice_download'));
            a.href = inv.pdfUrl;
            a.target = '_blank';
            a.rel = 'noopener';
            li.appendChild(a);
          } else {
            li.appendChild(el('span', 'skf-item__reason', t('invoice_no_pdf')));
          }
          ul.appendChild(li);
        });
        holder.appendChild(ul);
        var more = el('div', 'skf-actions');
        var rew = el('button', 'skf-btn skf-btn--ghost', t('invoice_rewrite_cta'));
        rew.type = 'button';
        rew.addEventListener('click', function () { S.answers.billingRewriteRequested = true; persist(); advance(step); });
        more.appendChild(rew);
        holder.appendChild(more);
      })
      .catch(function (err) {
        clear(holder);
        holder.appendChild(errorNote(messageForError(err)));
      });
  }

  /* --- Meine Meldungen (Statusseite) --- */
  function renderCases(step) {
    var c = card(t('cases_title'), t('cases_text'));
    var holder = el('div', 'skflow-cases');
    c.appendChild(holder);
    shell(step.id, [c]);
    loading(holder);
    api('/self-service/sessions/' + S.session.id + '/cases')
      .then(function (rows) {
        S.cases = rows || [];
        clear(holder);
        if (!S.cases.length) {
          var e = el('div', 'skf-empty');
          e.appendChild(el('p', 'skf-empty__title', t('cases_none_title')));
          e.appendChild(el('p', 'skf-empty__text', t('cases_none_text')));
          var a = el('a', 'skf-btn skf-btn--ghost', t('ui_other_case'));
          a.href = CFG.helpUrl || '/pages/hilfe';
          e.appendChild(a);
          holder.appendChild(e);
          return;
        }
        var ul = el('ul', 'skflow-cases__list');
        S.cases.forEach(function (row) {
          var li = el('li', 'skflow-case');
          li.appendChild(el('p', 'skflow-case__num', row.caseNumber));
          li.appendChild(el('p', 'skflow-case__type', t('case_type_' + row.caseType) || row.caseType));
          var state = el('p', 'skflow-case__state skflow-case__state--' + (row.state || 'received'));
          state.textContent = t('case_state_' + (row.state || 'received'));
          li.appendChild(state);
          if (row.createdAt) li.appendChild(el('p', 'skflow-case__date', niceDateTime(row.createdAt)));
          ul.appendChild(li);
        });
        holder.appendChild(ul);
      })
      .catch(function (err) {
        clear(holder);
        holder.appendChild(errorNote(messageForError(err)));
      });
  }

  /* --- Abgabegespraech: Rueckruf-Terminwahl ---------------------------------
     ⛔ Die Telefonpflicht bleibt. Diese Schritte erfassen NUR den Wunschtermin
     fuer den Rueckruf + die Rueckrufnummer — es gibt keine Web-Bestaetigung
     des Gespraechs und keine Freigabe durch den Kunden. */

  function fmtAbgabeWindow(w) {
    if (!w) return '';
    var label = t(w.window === 'evening' ? 'ab_window_evening' : 'ab_window_midday');
    var d = new Date(w.date + 'T12:00:00');
    if (isNaN(d.getTime())) return w.date + ' · ' + label;
    var day;
    try {
      day = d.toLocaleDateString(CFG.locale || 'de', { weekday: 'short', day: '2-digit', month: '2-digit' });
    } catch (e) { day = w.date; }
    return day + ' · ' + label;
  }

  /* Status-Check: Ist die Bestellung wirklich abgabe-pflichtig und offen?
     Wenn nicht: ehrliche Antwort statt Formular. */
  function renderAbgabeCheck(step) {
    var c = card(t('ab_check_title'), null);
    var holder = el('div', 'skflow-abgabe');
    c.appendChild(holder);
    shell(step.id, [c]);
    loading(holder);

    api('/self-service/sessions/' + S.session.id + '/abgabe')
      .then(function (data) {
        S.abgabe = data || {};
        persist();
        clear(holder);

        if (S.abgabe.pending) {
          var info = note('info', t('ab_check_pending_text'));
          if (info) holder.appendChild(info);
          if (S.abgabe.existingRequest && S.abgabe.existingRequest.windows && S.abgabe.existingRequest.windows.length) {
            var lines = S.abgabe.existingRequest.windows.map(fmtAbgabeWindow).join(', ');
            var ex = note('good', t('ab_check_existing', { windows: lines }));
            if (ex) holder.appendChild(ex);
          }
          holder.appendChild(actions({
            backId: 'start',
            label: t('ab_check_continue'),
            disabled: false,
            onNext: function () { advance(step); }
          }));
          return;
        }

        /* Kein offenes Abgabegespraech: entweder schon erledigt oder nie noetig.
           Beides ist eine gute Nachricht — und endet hier, ohne Formular. */
        var box = el('div', 'skf-empty');
        box.appendChild(el('p', 'skf-empty__title', t(S.abgabe.completed ? 'ab_check_done_title' : 'ab_check_none_title')));
        box.appendChild(el('p', 'skf-empty__text', t(S.abgabe.completed ? 'ab_check_done_text' : 'ab_check_none_text')));
        holder.appendChild(box);
        var row = el('div', 'skf-actions');
        var toStatus = el('a', 'skf-btn skf-btn--primary', t('ab_check_status_cta'));
        toStatus.href = (CFG.flowBase || '/pages/hilfe') + '-sendungsstatus';
        row.appendChild(toStatus);
        var toHelp = el('a', 'skf-btn skf-btn--ghost', t('ui_other_case'));
        toHelp.href = CFG.helpUrl || '/pages/hilfe';
        row.appendChild(toHelp);
        holder.appendChild(row);
      })
      .catch(function (err) {
        clear(holder);
        holder.appendChild(errorNote(messageForError(err)));
      });
  }

  /* Zeitfenster: 1-3 aus den real angerufenen Fenstern (Server liefert sie). */
  function renderAbgabeWindows(step) {
    if (!S.abgabe || !Array.isArray(S.abgabe.windows) || !S.abgabe.windows.length) {
      go('status', true);
      return;
    }
    var c = card(t(step.titleKey), t(step.textKey));
    var form = el('div', 'skflow-form');
    var list = el('div', 'skf-options');
    var chosen = Array.isArray(S.answers[step.key]) ? S.answers[step.key].slice() : [];
    function keyOf(w) { return w.date + '|' + w.window; }
    var warn = el('div', 'skflow-errbox');

    S.abgabe.windows.forEach(function (w) {
      var lab = el('label', 'skf-option');
      var inp = el('input', 'skf-option__input');
      inp.type = 'checkbox';
      inp.name = step.key;
      inp.value = keyOf(w);
      if (chosen.some(function (x) { return keyOf(x) === keyOf(w); })) inp.checked = true;
      lab.appendChild(inp);
      lab.appendChild(el('span', 'skf-option__mark'));
      var body = el('span', 'skf-option__body');
      body.appendChild(el('span', 'skf-option__title', fmtAbgabeWindow(w)));
      lab.appendChild(body);
      list.appendChild(lab);
      inp.addEventListener('change', function () {
        clear(warn);
        var pos = -1;
        chosen.forEach(function (x, i) { if (keyOf(x) === keyOf(w)) pos = i; });
        if (inp.checked && pos === -1) {
          if (chosen.length >= 3) {
            inp.checked = false;
            var m = note('warn', t('ab_windows_max'));
            if (m) warn.appendChild(m);
            return;
          }
          chosen.push({ date: w.date, window: w.window });
        }
        if (!inp.checked && pos !== -1) chosen.splice(pos, 1);
        S.answers[step.key] = chosen.slice();
        persist();
        sync();
      });
    });
    form.appendChild(list);
    form.appendChild(warn);

    var act = actions({
      backId: prevOf(step.id),
      hint: t(step.hintKey || 'ui_next_hint'),
      onNext: function () { advance(step); }
    });
    form.appendChild(act);
    c.appendChild(form);

    function sync() {
      var btn = act.querySelector('[data-skf-next]');
      if (chosen.length >= 1 && chosen.length <= 3) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', '');
    }
    window.setTimeout(sync, 0);
    shell(step.id, [c]);
  }

  /* Telefonnummer bestaetigen/korrigieren. Die Nummer der Bestellung kommt nur
     MASKIERT vom Server — die Rohnummer sieht der Browser nie. */
  function renderAbgabePhone(step) {
    if (!S.abgabe) { go('status', true); return; }
    var c = card(t(step.titleKey), t(step.textKey));
    var form = el('div', 'skflow-form');
    var hasPhone = !!(S.abgabe.hasPhone && S.abgabe.phoneMasked);
    var mode = S.answers.phoneAction || (hasPhone ? 'keep' : 'new');
    if (!hasPhone) mode = 'new';

    var group = el('div', 'skf-options');
    var inputWrap = el('div', 'skflow-field');
    var lab2 = el('label', 'skflow-field__label', t('ab_phone_input_label'));
    lab2.setAttribute('for', 'skflow-abphone');
    var inp = el('input', 'skflow-field__input');
    inp.type = 'tel';
    inp.id = 'skflow-abphone';
    inp.autocomplete = 'tel';
    inp.setAttribute('inputmode', 'tel');
    if (S.answers[step.key] && S.answers.phoneAction === 'new') inp.value = S.answers[step.key];
    inputWrap.appendChild(lab2);
    inputWrap.appendChild(inp);
    inputWrap.appendChild(el('p', 'skflow-field__help', t('ab_phone_help')));
    var warn = el('div', 'skflow-errbox');

    function phonePlausible(v) {
      var digits = String(v || '').replace(/\D/g, '');
      return digits.length >= 6 && digits.length <= 16;
    }

    function applyMode() {
      S.answers.phoneAction = mode;
      inputWrap.hidden = mode !== 'new';
      persist();
      sync();
    }

    if (hasPhone) {
      [
        { value: 'keep', label: t('ab_phone_keep', { masked: S.abgabe.phoneMasked }) },
        { value: 'new', label: t('ab_phone_new') }
      ].forEach(function (opt) {
        var lab = el('label', 'skf-option');
        var radio = el('input', 'skf-option__input');
        radio.type = 'radio';
        radio.name = 'phoneAction';
        radio.value = opt.value;
        if (mode === opt.value) radio.checked = true;
        lab.appendChild(radio);
        lab.appendChild(el('span', 'skf-option__mark'));
        var body = el('span', 'skf-option__body');
        body.appendChild(el('span', 'skf-option__title', opt.label));
        lab.appendChild(body);
        group.appendChild(lab);
        radio.addEventListener('change', function () { mode = opt.value; applyMode(); });
      });
      form.appendChild(group);
    }
    form.appendChild(inputWrap);
    form.appendChild(warn);

    var act = actions({
      backId: prevOf(step.id),
      hint: t('ab_phone_invalid'),
      onNext: function () { advance(step); }
    });
    form.appendChild(act);
    c.appendChild(form);

    inp.addEventListener('input', function () {
      S.answers[step.key] = inp.value.trim();
      persist();
      sync();
    });

    function sync() {
      clear(warn);
      var btn = act.querySelector('[data-skf-next]');
      var ok = mode === 'keep' || phonePlausible(inp.value);
      if (mode === 'new' && inp.value.trim() && !phonePlausible(inp.value)) {
        var m = note('warn', t('ab_phone_invalid'));
        if (m) warn.appendChild(m);
      }
      if (ok) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
    }
    applyMode();
    shell(step.id, [c]);
  }

  /* --- Triage (die zwei Tueren) --- */
  function renderTriage() {
    var c = card(t(FLOW.titleKey), t(FLOW.introKey));
    var ul = el('ul', 'skflow-triage');
    (FLOW.targets || []).forEach(function (tg) {
      var li = el('li');
      var a = el('a', 'skflow-triage__link');
      a.href = (CFG.flowBase || '/pages/hilfe') + '-' + tg.slug;
      a.appendChild(el('span', 'skflow-triage__title', t(tg.titleKey)));
      a.appendChild(el('span', 'skflow-triage__text', t(tg.textKey)));
      li.appendChild(a);
      ul.appendChild(li);
    });
    c.appendChild(ul);
    clear(app);
    var wrap = el('div', 'skf skflow');
    wrap.appendChild(c);
    wrap.appendChild(contactBlock());
    wrap.appendChild(otherCasesLink());
    app.appendChild(wrap);
  }

  /* --- Pruefen + Absenden --- */
  function renderReview(step) {
    var c = card(t('review_title'), t('review_text'));
    var dl = el('dl', 'skflow-review');
    var list = activeSteps();
    list.forEach(function (st) {
      if (st.kind === 'review' || st.kind === 'done' || st.kind === 'ident' || st.kind === 'vital') return;
      var val = summarize(st);
      if (!val) return;
      var dt = el('dt', 'skflow-review__k', t(st.titleKey || ('step_' + st.kind)));
      var dd = el('dd', 'skflow-review__v');
      dd.appendChild(document.createTextNode(val));
      var edit = el('button', 'skflow-review__edit', t('review_edit'));
      edit.type = 'button';
      edit.addEventListener('click', function () { go(st.id); });
      dd.appendChild(edit);
      dl.appendChild(dt);
      dl.appendChild(dd);
    });
    if (S.media.length) {
      dl.appendChild(el('dt', 'skflow-review__k', t('review_media')));
      dl.appendChild(el('dd', 'skflow-review__v', t('upload_already', { count: S.media.length })));
    }
    c.appendChild(dl);

    (FLOW.promises || []).forEach(function (p) { var x = note(p.kind, t(p.key)); if (x) c.appendChild(x); });

    var errBox = el('div', 'skflow-errbox');
    c.appendChild(errBox);

    var act = actions({
      backId: prevOf(step.id),
      label: t('ui_submit'),
      disabled: false,
      onNext: function () { submitCase(); }
    });
    c.appendChild(act);

    function submitCase() {
      if (S.busy) return;
      S.busy = true;
      clear(errBox);
      var btn = act.querySelector('[data-skf-next]');
      btn.setAttribute('disabled', '');
      btn.textContent = t('ui_submitting');

      /* Abgabegespraech: eigener Endpoint — ein Rueckruf-WUNSCH, kein Fall.
         ⛔ Bestaetigt nichts und gibt nichts frei; die Telefonpflicht bleibt. */
      if (FLOW.submitKind === 'abgabe') {
        var abBody = {
          windows: S.answers.callbackWindows || [],
          phoneAction: S.answers.phoneAction === 'new' ? 'new' : 'keep',
          locale: CFG.locale || 'de'
        };
        if (abBody.phoneAction === 'new') abBody.phone = S.answers.callbackPhone || '';
        api('/self-service/sessions/' + S.session.id + '/abgabe', { method: 'POST', body: abBody })
          .then(function (data) {
            S.result = {
              abgabe: true,
              windows: (data && data.windows) || abBody.windows,
              phoneMasked: (data && data.phoneMasked) || null
            };
            S.busy = false;
            persist();
            go('fertig');
          })
          .catch(function (err) {
            S.busy = false;
            btn.textContent = t('ui_submit');
            btn.removeAttribute('disabled');
            if (err.code === 'not_pending') {
              /* Zwischenzeitlich erledigt/kein Gespraech noetig — ehrlich sagen. */
              var done = err.payload && err.payload.completed;
              errBox.appendChild(note('good', t(done ? 'ab_check_done_text' : 'ab_check_none_text')));
              return;
            }
            errBox.appendChild(errorNote(messageForError(err)));
          });
        return;
      }

      var answers = {};
      Object.keys(S.answers).forEach(function (k) { answers[k] = S.answers[k]; });
      /* Mehrfachpack-Stueckzahl nur senden, wenn der Schritt aktiv war —
         sonst koennte ein veralteter Wert (Positionen geaendert) mitgehen. */
      var packStep = (FLOW.steps || []).filter(function (st) { return st.kind === 'packunits'; })[0];
      if (packStep && !condOk(packStep.when)) { delete answers.affectedUnits; delete answers.totalUnits; }
      answers.flow = FLOW.id;
      answers.source = 'theme_flow';
      /* Umleitung transparent machen: welche Kachel der Kunde WIRKLICH
         angeklickt hat. Der caseType folgt der Klassifikation (FLOW nach
         applyFlowSwitch), nicht der Kachel. */
      if (S.flowSwitch) {
        answers.entryFlow = S.flowSwitch.from;
        answers.autoRedirected = true;
      }
      if (CFG.testMode) answers.isTest = true;
      var body = {
        caseType: FLOW.caseType,
        answers: answers,
        customerMessage: (CFG.testMode ? t('test_prefix') + ' ' : '') + (S.answers.message || ''),
        media: S.media.map(function (m) { return { objectKey: m.objectKey, mimeType: m.mimeType, sizeBytes: m.sizeBytes }; }),
        locale: CFG.locale || 'de'
      };
      if (S.answers.customerName) body.customerName = S.answers.customerName;
      api('/self-service/sessions/' + S.session.id + '/cases', { method: 'POST', body: body })
        .then(function (data) {
          S.result = data;
          S.busy = false;
          persist();
          go('fertig');
        })
        .catch(function (err) {
          S.busy = false;
          btn.textContent = t('ui_submit');
          btn.removeAttribute('disabled');
          errBox.appendChild(errorNote(messageForError(err)));
          if (err.code === 'case_not_dispatched' && err.payload && err.payload.caseNumber) {
            errBox.appendChild(el('p', 'skflow-derived', t('done_case_label') + ': ' + err.payload.caseNumber));
          }
        });
    }

    shell(step.id, [c]);
  }

  function summarize(st) {
    if (st.kind === 'packunits') {
      var ps = packSelections();
      if (!ps.length) return null;
      return ps.map(function (p) {
        return (p.title || p.sku) + ': ' + (p.affectedUnits || 1) + ' / ' + (p.packUnits * Math.max(1, p.quantity || 1));
      }).join(', ');
    }
    if (st.kind === 'abgabewindows') {
      var wv = S.answers[st.key];
      if (!Array.isArray(wv) || !wv.length) return null;
      return wv.map(fmtAbgabeWindow).join(', ');
    }
    if (st.kind === 'abgabephone') {
      if (S.answers.phoneAction === 'new') return S.answers[st.key] || null;
      return (S.abgabe && S.abgabe.phoneMasked) || null;
    }
    var v = S.answers[st.key];
    if (v === undefined || v === null || v === '') return null;
    if (st.kind === 'radio') {
      var found = null;
      (st.options || []).forEach(function (o) { if (o.value === v) found = t(o.titleKey); });
      return found || String(v);
    }
    if (st.kind === 'checkgroup') {
      if (!Array.isArray(v) || !v.length) return null;
      return v.map(function (val) {
        var lbl = val;
        (st.options || []).forEach(function (o) { if (o.value === val) lbl = t(o.titleKey); });
        return lbl;
      }).join(', ');
    }
    if (st.kind === 'consent') return v ? t('ui_answer_yes') : null;
    if (st.kind === 'items') {
      if (!Array.isArray(v) || !v.length) return null;
      return v.map(function (i) { return (i.title || i.sku) + (st.withQty ? ' × ' + i.quantity : ''); }).join(', ');
    }
    if (st.kind === 'number') return String(v);
    if (st.kind === 'date') return niceDate(v);
    if (st.kind === 'fields') {
      return Object.keys(v).map(function (k) { return v[k]; }).filter(Boolean).join(', ');
    }
    return String(v);
  }

  /* --- Fertig --- */
  function renderDone(step) {
    var r = S.result || {};
    var box = el('div', 'skf-done');
    box.appendChild(el('span', 'skf-done__ic', '✓'));
    box.appendChild(el('h2', 'skf-done__title', t('done_title')));
    if (r.caseNumber) {
      var p = el('p', 'skf-done__case');
      p.appendChild(el('span', 'skf-done__case-label', t('done_case_label')));
      p.appendChild(el('span', 'skf-done__case-value', r.caseNumber));
      var copy = el('button', 'skf-done__copy', t('done_copy'));
      copy.type = 'button';
      copy.setAttribute('data-skf-copy', '');
      copy.setAttribute('data-skf-copy-value', r.caseNumber);
      p.appendChild(copy);
      box.appendChild(p);
    }
    /* Abgabegespraech: statt Fallnummer die gewaehlten Rueckruf-Fenster. */
    if (r.abgabe && r.windows && r.windows.length) {
      var pw = el('p', 'skf-done__case');
      pw.appendChild(el('span', 'skf-done__case-label', t('ab_done_windows_label')));
      pw.appendChild(el('span', 'skf-done__case-value', r.windows.map(fmtAbgabeWindow).join(' · ')));
      box.appendChild(pw);
    }
    var when = note('info', t(FLOW.doneWhenKey || 'done_when_default'));
    if (when) box.appendChild(when);
    (FLOW.doneNotes || []).forEach(function (n) { var x = note(n.kind, t(n.key)); if (x) box.appendChild(x); });

    box.appendChild(el('p', 'skf-done__next-title', t('done_next_title')));
    var ol = el('ol', 'skf-done__next');
    (FLOW.doneNextKeys || ['done_next_1', 'done_next_2', 'done_next_3']).forEach(function (k) { ol.appendChild(el('li', null, t(k))); });
    box.appendChild(ol);

    var row = el('div', 'skf-done__actions');
    var status = el('a', 'skf-btn skf-btn--primary', t('done_status_cta'));
    status.href = (CFG.flowBase || '/pages/hilfe') + '-meine-meldungen';
    row.appendChild(status);
    var again = el('a', 'skf-btn skf-btn--ghost', t('ui_other_case'));
    again.href = CFG.helpUrl || '/pages/hilfe';
    again.addEventListener('click', function () { forget(); });
    row.appendChild(again);
    box.appendChild(row);

    clear(app);
    var wrap = el('div', 'skf skflow');
    wrap.appendChild(box);
    wrap.appendChild(contactBlock());
    app.appendChild(wrap);
    if (window.SKFlowKit && window.SKFlowKit.boot) window.SKFlowKit.boot(app);
  }

  /* ============================================================
     Ablaufsteuerung
     ============================================================ */

  function prevOf(id) {
    var idx = stepIndex(id);
    var prev = idx > 0 ? activeSteps()[idx - 1].id : 'start';
    /* Mit bestehender Sitzung springt renderIdent sofort weiter — ein
       "Zurueck" auf ident waere also ein Bounce. Dann lieber zur Startkarte. */
    if (prev === 'ident' && S.session) return 'start';
    return prev;
  }

  function advance(step) {
    /* Weiterleitung in einen anderen Flow (Triage-Optionen) */
    if (step.routes) {
      var val = S.answers[step.key];
      var target = step.routes[val];
      if (target) {
        forget();
        window.location.href = (CFG.flowBase || '/pages/hilfe') + '-' + target;
        return;
      }
    }
    var idx = stepIndex(step.id);
    var list = activeSteps();
    var next = list[idx + 1];
    go(next ? next.id : 'fertig');
  }

  function render(rawStepId) {
    applyFlowSwitch();
    var stepId = guard(rawStepId);
    if (stepId !== rawStepId) {
      try { window.history.replaceState({ skflow: stepId }, '', urlFor(stepId)); } catch (e) {}
    }
    if (stepId === 'start') {
      /* Serverseitige Startkarte stehen lassen — sie ist der No-JS-Fallback.
         Auch fuer die Tueren (triage): deren Wegweiser rendert die Section
         serverseitig als echte Links. Frueher hat die Engine hier ZUSAETZLICH
         eine JS-Triage-Karte angehaengt — Titel und Kontaktblock standen
         doppelt auf der Seite. */
      app.removeAttribute('data-skflow-hidden');
      var startCard = document.querySelector('[data-skflow-start]');
      if (startCard) startCard.hidden = false;
      clear(app);
      return;
    }
    var startCard2 = document.querySelector('[data-skflow-start]');
    if (startCard2) startCard2.hidden = true;

    if (stepId === 'ident') { renderIdent(); return; }
    var step = stepById(stepId);
    if (!step) { renderIdent(); return; }
    switch (step.kind) {
      case 'radio': renderRadio(step); break;
      case 'checkgroup': renderCheckgroup(step); break;
      case 'consent': renderConsent(step); break;
      case 'items': renderItems(step); break;
      case 'number': renderNumber(step); break;
      case 'packunits': renderPackUnits(step); break;
      case 'date': renderDate(step); break;
      case 'text': renderText(step); break;
      case 'fields': renderFields(step); break;
      case 'vital': renderVital(step); break;
      case 'upload': renderUpload(step); break;
      case 'status': renderStatus(step); break;
      case 'invoices': renderInvoices(step); break;
      case 'cases': renderCases(step); break;
      case 'abgabecheck': renderAbgabeCheck(step); break;
      case 'abgabewindows': renderAbgabeWindows(step); break;
      case 'abgabephone': renderAbgabePhone(step); break;
      case 'review': renderReview(step); break;
      case 'done': renderDone(step); break;
      default: renderIdent(); break;
    }
  }

  /* ============================================================
     Start
     ============================================================ */

  restore();

  /* Startknoepfe auf der serverseitigen Karte uebernehmen. */
  document.querySelectorAll('[data-skflow-go]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      ev.preventDefault();
      go(a.getAttribute('data-skflow-go') || 'ident');
    });
  });

  /* Auch fuer die Tueren normal rendern: guard() mappt triage immer auf
     'start', und dort bleibt die serverseitige Karte mit ihren Wegweisern
     stehen (frueher haengte renderTriage() hier eine ZWEITE Karte an). */
  render(currentStepId());
})();
